import { IBlock } from "../../../framework/src/IBlock";
import { Message } from "../../../framework/src/Message";
import { runEngine } from "../../../framework/src/RunEngine";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, { getName } from "../../../framework/src/Messages/MessageEnum";

// Customizable Area Start
import React from "react";
import moment from "moment";

import { IFilter } from "../../../components/src/FilterPopover";
import {
  apiCall,
  makeApiMessage as MakeApiMessage,
} from "../../../components/src/common";
import { checkedIcon, unCheckedIcon } from "./assets";
import AutoComplete from "@material-ui/lab/Autocomplete";
import { Box, TextField } from "@material-ui/core";
import { ISortingData } from "../../../components/src/SortingTableHeader";
import {
  ICustomer,
  IOrder,
} from "../../OrderCreation/src/OrderCreationController.web";
import { IUserContext } from "../../../components/src/PageContainer/PageContainerController";
import {
  checkForOrderPermissonStatus,
  CustomEnums,
  getCustomEnumName,
  navigateTo,
  customPermissionApiKey,
  OrderPermissionStatus,
  checkIsFilterApplied,
  sortStringCondition,
  renderBooleanConditions,
  sortCondition,
  getDateRangeForQuery,
  updateAccountType
} from "../../utilities/src/CustomBlockHelpers";
import { IOrderData } from "./OrderDetailsController.web";
import { IMyUser } from "./../../navigationmenu/src/utils";
import { toString, uniqBy, debounce } from "lodash";
import { PermissionGroupArray } from "../../../blocks/navigationmenu/src/utils";
import { ReceiptPrinterSetting } from "../../navigationmenu/src/HeaderController.web";
import { globalReceiptPrinterSetting, InvoiceRawData, SalesPostedRawData } from "../../print/src/PrintController";
import { getStorageData } from "framework/src/Utilities";

const TAB_STATUS_LIST = [
  "coming_to_store",
  "in_store",
  "cleaning",
  "ready",
  "delivered",
  "send_to_deadstock",
  "cancelled"
];

const TAB_SETTING_MAP = {
  2: "receipt_print_clean_page",
  3: "receipt_print_ready_page",
  4: "receipt_print_delivered_page"
} as { [key: number]: keyof ReceiptPrinterSetting }

export interface StoreOrder {
  id: string;
  type: string;
  checked?: boolean;
  attributes: {
    id: number;
    order_number: string;
    account_id: number;
    notes: string;
    created_at: string;
    internal_status: string;
    is_quick_drop: boolean;
    send_to_zatca: boolean;
    plant_status_display_name: string;
    order_items: {
      name: string;
      qty: number;
      second_name: string;
      service_short_name: string;
    }[];
    total_items: number;
    total_pieces: number;
    customer: {
      id: number;
      full_phone_number: string;
      email: string;
      full_name: string;
    };
    paid: {
      id: number;
      name: string;
    }[];
    paid_at: string;
    currency: string;
    total: string;
    rewash_order: boolean;
  };
}

export interface IContactInfo {
  id: number;
  full_name: string | null;
  phone_number: string | null;
  full_phone_number?: string;
  // Drivers only; absent for a customer.
  assigned_at?: string | null;
}

export interface IAssignableDriver {
  id: number;
  full_name: string | null;
  phone_number: string | null;
  role: string | null;
  is_available: boolean | null;
  location_fresh: boolean | null;
  active_requests: number;
  max_concurrent: number | null;
  assigned_to_this_request: boolean;
}

export type DriverLeg = "pickup" | "delivery";

export interface IMobileServiceRequest {
  id: number;
  type: string;
  attributes: {
    id: number;
    request_number: string;
    status: string;
    pickup_type: string;
    pickup_scheduled_at: string | null;
    mobile_service: {
      id: number;
      name: string;
      name_ar: string | null;
    };
    customer: {
      id: number;
      full_name: string;
      phone_number: string;
      full_phone_number?: string;
    };
    pickup_address: {
      id: number;
      label: string;
      address: string;
      latitude: string;
      longitude: string;
    } | null;
    slot: any;
    notes: string | null;
    store: {
      id: number | null;
      name: string | null;
    } | null;
    created_at: string;
  };
}

interface Config {
  maxWidth: number;
  config: string;
}

export const configJSON = require("./config");

export interface Props {
  navigation: any;
  id: string;
}

export interface Option {
  label: string;
  value: string;
  tabId: number;
}

export interface PermissionOption {
  label: string;
  value: string;
  tabId: number;
  permission: boolean
}

export interface MetaData {
  orders?: number;
  pieces?: number;
  total?: string;
  unpaid_amount?: string;
  currency?: string;
  total_pages?: number;
  total_count?: number;
  current_page?: number;
  next_page?: number;
  pervious_page?: number;
}

export interface IStoreItem {
  id: string;
  type: string;
  attributes: StoreAttributes;
}

export interface StoreAttributes {
  id: string;
  store_name: string;
}

export interface FilterNumberResponse {
  id: number;
  full_phone_number: string;
  country_code: number;
  phone_number: number;
  email: string;
  full_name: string;
}

export interface SectionOptionResponse {
  active: boolean;
  id: number;
  label: string;
  selected?: boolean;
}
export interface PaymentOptionResponse {
  active: boolean;
  id: number;
  name: string;
  selected?: boolean;
}

export interface SectionListResponse {
  id: number;
  attributes: { 
    section_name: string; 
    active: boolean 
  }
}

export interface EmployeeListResponse {
  attributes: {
    id: string, 
    first_name: string
  }
}

export interface SendToDriverResponse {
  use_raw_printing_receipt: boolean
  errors?: string; 
  status?: number, 
  message?: string
  data?: SalesPostedRawData
}
// Customizable Area End

export interface S {
  // Customizable Area Start
  orderToPrint: IOrderData | null;
  driverList: Array<Option>;
  drawerWidth: number;
  popOverOpened: boolean;
  popOverItemId: string;
  popOverItemStatus: string;
  popOverTop: number;
  popOverLeft: number;
  ordersList: IOrderData[];
  dropDownList: PermissionOption[];
  page: number;
  pageSize: number;
  isModalOpen: boolean;
  deactivated: boolean;
  filterAnchor: HTMLDivElement | undefined;
  filters: IFilter[];
  clickedCustomerType: StoreOrder | undefined;
  tabId: number;
  query: string;
  searchText: string;
  searchResult: boolean;
  isSuperAdmin?: boolean;
  showCheckBoxAndButton: boolean;
  selectedDropdownvalue: string | null;
  selectAllChecked: boolean;
  dropdownOptions: { section: string[] };
  sectionOptions: SectionOptionResponse[];
  paymentOptions: PaymentOptionResponse[]
  driversList: {label: string, value: string}[]
  orderMetaData: MetaData;
  storeList: {id:string; option: string}[];
  userData:  IMyUser;
  orderDetailPopup: boolean;
  orderData: IOrderData;
  selectedDriver: string;
  sendToDriverError: string;
  selectedOrders: Array<IOrderData>;
  userRefresh: Function;
  customerFilterNameList: string[];
  customerFilterNumberList: FilterNumberResponse[];
  customerNumberValue: string;
  unpaidDialogPopup: boolean;
  paymentModalVisible: boolean;
  customerId: string;
  customerData?: ICustomer;
  order?: { attributes: IOrder } | null;
  sortingData: ISortingData;
  storeId: string;
  storeName: string;
  isDrawerOpen: boolean;
  paymentClicked: boolean;
  unPaidOrderError: string;
  storeListPageNo: number;
  storeSearchText: string;
  selectedTab: string;
  errorMessage: string;
  unpaidDialogDetail:IOrderData[];
  permissionStatus: OrderPermissionStatus;
  b2bPermissionStatus: Partial<OrderPermissionStatus>;
  driverReceipt: string | SalesPostedRawData;
  useRawPrinting: boolean;
  showDriverReceiptConfirmation: boolean;
  selectedOrder: IOrderData | null;
  showDirectPaymentModal: boolean;
  ispaymentClicked: boolean;
  isButtonLoading: boolean;
  isLoadingOrderList: boolean
  isScanningOrder: boolean
  printerSetting: ReceiptPrinterSetting | null

  creditNoteOrder?: IOrderData;
  mobileServiceRequests: IMobileServiceRequest[];
  isMobileRequestsLoading: boolean;
  // Shared by the customer and the two driver icons — all carry the same
  // { id, full_name, phone_number } shape, so one popover serves them all.
  driverMenuAnchor: HTMLElement | null;
  driverMenuLeg: DriverLeg;
  assignableDrivers: IAssignableDriver[];
  assignableDriversLoading: boolean;
  // Keyed per leg, so the menu can mark the one assigned to the leg being
  // edited rather than either leg.
  currentDrivers: { pickup: number | null; delivery: number | null };
  assigningDriverId: number | null;
  contactInfoAnchor: HTMLElement | null;
  contactInfoData: IContactInfo | null;
  contactInfoTitle: string;
  mobileRequestDetailOpen: boolean;
  mobileRequestDetailData: any;
  mobileRequestDetailLoading: boolean;
  isAcceptingMobileRequest: boolean;
  isStartingPickup: boolean;
  pickupActionDialogOpen: boolean;
  pickupActionType: "" | "picked_up" | "pickup_rejected" | "customer_unavailable" | "delivered";
  pickupActionNotes: string;
  pickupActionImages: File[];
  isSubmittingPickupAction: boolean;
  isMarkingInStore: boolean;
  isAcceptingDelivery: boolean;
  isStartingDelivery: boolean;
  eventsExpanded: boolean;
  creditNotePresent?: boolean;
  isCreditNoteDialogOpen: boolean;
  creditNoteReceipt: string;
  hidden: boolean;
  addNote: string;
  isConfirmationChecked: boolean;
  creditLoader: boolean;
  openCrediNoteModalLoader: boolean;
  creditNoteOrderNumber: number | null;
  snackbarMessage: string;
  snackBarSeverity: string;
  isAppliedFilter: boolean;
  isB2BActive: boolean;
  // Notes Dialog State
  notesDialogOpen: boolean;
  currentOrderIdForNotes: string | null;
  tempNotes: string;
  isUpdatingNotes: boolean;
  // Customizable Area End
}

export interface SS {
  // Customizable Area Start
  id: any;
  // Customizable Area End
}

export default class OrdersController extends BlockComponent<Props, S, SS> {
  // Customizable Area Start
  getCallId: string = "";
  getStoreCallId: string = "";
  getMobileRequestsCallId: string = "";
  getMobileRequestDetailCallId: string = "";
  acceptMobileRequestCallId: string = "";
  startPickupCallId: string = "";
  pickupActionCallId: string = "";
  markInStoreCallId: string = "";
  getAssignableDriversCallId: string = "";
  assignDriverCallId: string = "";
  acceptDeliveryCallId: string = "";
  startDeliveryCallId: string = "";
  getOrderMessageId: string = "";
  getOrderReceiptCallId: string = "";
  getCustomerNameCallId: string = "";
  getCustomerNumberCallId: string = "";
  getServicesSuggestion: string = "";
  updateEmployeeCurrentStoreApiId: string = "";
  tableRefs: HTMLElement | null = null;
  getSectionListApiCallId: string = "";
  getPaymentListApiCallId: string = "";
  employeeListMessageId: string = "";
  sendToDriverMessageId: string = "";
  getDriverReceiptMessageId: string = "";
  updateStatusToCleanMessageId: string = "";
  updateStatusToReceivedMessageId: string = "";
  updateStatusToDeliveredMessageId: string = "";
  updateStatusToAnyMessageId: string = "";
  updateStatusToDeadStocksMessageId: string = "";
  updatePlantCarpetFurnitureStatusMsgId: string = "";
  updateSendToDriverCarpetFurOrderMsgId: string = "";
  textLabelStyle: React.CSSProperties;
  textInputStyle: React.CSSProperties;
  storeListEmptyFlag = false;
  getOrderDetailMessageId: string = "";
  getOrderItemsMessageId: string = "";
  getCreditNoteMessageId: string = "";
  getCreateCreditNoteMessageId: string = "";
  generateOrderInvoiceCallId: string = "";
  getRawOrderInvoiceDataCallId: string = "";
  scanOrderApiCallId: string = "";
  updateOrderNotesCallId: string = "";

  postLocationMessageId: string = "";
  locationPollingIntervalId: ReturnType<typeof setInterval> | null = null;
  locationPollingRequestId: string | null = null;
  pendingStartPickupRequestId: string | null = null;
  pendingStartDeliveryRequestId: string | null = null;

  scannedOrderId = ""
  
  savedRawPrintDatasMap = new Map<string, InvoiceRawData>()
  // Customizable Area End

  constructor(props: Props) {
    super(props);
    this.subScribedMessages = [
      getName(MessageEnum.RestAPIResponceMessage),
      // Customizable Area Start
      getName(MessageEnum.NavigationPayLoadMessage),
      getName(MessageEnum.RestAPIResponceDataMessage),
      getName(MessageEnum.SessionSaveMessage),
      getName(MessageEnum.SessionResponseMessage),
      getName(MessageEnum.PrintSettingsMessage),
      getName(MessageEnum.LayoutDataMessage),
      getName(MessageEnum.SearchTextMessage),
      getName(MessageEnum.BroadcastNavbarDataMessage),
      getCustomEnumName(CustomEnums.DataForRedirectionFromNotification),
      getCustomEnumName(CustomEnums.CustomReducerPayload),
      getCustomEnumName(CustomEnums.ReceiptPrinterSettingUpdated)
      // Customizable Area End
    ];

    this.receive = this.receive.bind(this);

    runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);

    // Customizable Area Start
    this.textLabelStyle = {
      fontFamily: "Montserrat",
      color: "#000",
      lineHeight: "22px",
      fontWeight: 600,
      fontSize: "14px",
    };
    this.textInputStyle = {
      marginTop: "4px",
      height: "44px",
      width: "190px",
      fontFamily: "Montserrat !important",
      marginBottom: "8px",
    };
    // Customizable Area End

    this.state = {
      // Customizable Area Start
      paymentClicked: false,
      storeListPageNo: 1,
      storeSearchText: "",
      orderToPrint: null,
      selectedOrders: [],
      sendToDriverError: "",
      selectedDriver: "",
      driverList: [],
      ordersList: [],
      dropDownList: [],
      userRefresh: () => {},
      page: 1,
      pageSize: 100,
      popOverItemId: "",
      popOverItemStatus: "",
      isModalOpen: false,
      deactivated: false,
      drawerWidth: 0,
      popOverOpened: false,
      popOverLeft: 0,
      popOverTop: 0,
      filterAnchor: undefined,
      customerFilterNameList: [],
      customerFilterNumberList: [],
      customerNumberValue: "",
      printerSetting: {...globalReceiptPrinterSetting},
      filters: [
        {
          title: "Services",
          type: "autocompolete",
          value: "",
          apiKey: "services",
          options: [],
        },
        {
          title: "Section",
          value: "",
          type: "multipleSelect",
          options: [],
        },
        {
          title: "Customer",
          type: "custom",
          value: "",
          onClear: () => {
            return this.clearCustomerFilter();
          },
          customRender: () => {
            return this.renderfilterCustomer();
          },
        },
        {
          title: "Payment Method",
          type: "multipleSelect",
          value: "",
          options: []
        },
        {
          title: "Payment Status",
          type: "select",
          options: [
            {
              label: "Confirmed",
              value: "Paid",
            },
            {
              label: "Pending",
              value: "Unpaid",
            }
          ],
          value: "",
        },
        {
          title: "Status",
          type: "select",
          options: [
            {
              label: "Cleaning",
              value: "cleaning",
            },
            {
              label: "Ready to Deliver",
              value: "ready",
            },
          ],
          value: "",
        },
        {
          title: "Due",
          type: "dateselect",
          datevalue: { from: "", to: "" },
          value: "",
          options: [
            {
              label: "Today",
              value: "today",
            },
            {
              label: "Today & Overdue",
              value: "over_due",
            },
            {
              label: "Tomorrow",
              value: "tomorrow",
            },
            {
              label: "Specific Dates",
              value: "specific",
            }
          ],
        },
        {
          title: "Order Type",
          type: "select",
          options: [
            {
              label: "B2C Order",
              value: "B2cOrder",
            },
            {
              label: "B2B Order",
              value: "B2bOrder",
            },
            {
              label: "Golden Point Order",
              value: "goldenPointOrder",
            }
          ],
          value: "",
        },
       
      ],
      clickedCustomerType: undefined,
      tabId: 0,
      searchText: "",
      searchResult: false,
      sectionOptions: [],
      paymentOptions: [],
      query: "",
      showCheckBoxAndButton: false,
      selectedDropdownvalue: "",
      selectAllChecked: false,
      dropdownOptions: {
        section: [],
      },
      driversList: [{ label: "Driver 1", value: "value" }],
      orderMetaData: {},
      storeList: [],
      userData: {} as IMyUser,
      orderDetailPopup: false,
      orderData: {} as IOrderData,
      unpaidDialogPopup: false,
      paymentModalVisible: false,
      customerId: "",
      sortingData: {
        order_number: "",
        created_at: "",
        customer: "",
        full_phone_number: "",
        total: "",
        internal_status: "",
      },
      storeId: "",
      storeName: "",
      unPaidOrderError: "",
      isDrawerOpen: localStorage.getItem("isPinned") == "true",
      selectedTab: configJSON.plantCleaningTxt,
      errorMessage: "",
      unpaidDialogDetail:[],
      permissionStatus: {
        mainPermission: false,
        createOrderPermission: false,
        viewOrderPermission: false,
        editOrderPermission: false,
        sendToDriverAction: false,
        cleanAction: false,
        rewashAction: false,
        sendToDeadStockAction: false,
        storeDropdownAction: false,
        cleaningDropdownAction: false,
        readyDropdownAction: false,
        zatcaLogsAccess: false,
        viewCreditOrderAccess: false,
        createCreditNoteAccess: false,
        comingToStoreAccess: false,
        comingToStoreAllAccess: false,
        changeDriverAccess: false
      },
      b2bPermissionStatus: {
        createOrderPermission: false,
        viewOrderPermission: false,
        editOrderPermission: false
      },
      driverReceipt: "",
      useRawPrinting: false,
      showDriverReceiptConfirmation: false,
      selectedOrder: null,
      showDirectPaymentModal: false,
      ispaymentClicked: false,
      isButtonLoading: false,
      isLoadingOrderList: true,
      isScanningOrder: false,
      creditNoteReceipt: "",
      hidden: true,
      isCreditNoteDialogOpen: false,
      creditNoteOrder: undefined,
      creditNotePresent: false,
      addNote: "",
      creditLoader: false,
      isConfirmationChecked: true,
      openCrediNoteModalLoader: false,
      creditNoteOrderNumber: null,
      snackbarMessage: "",
      snackBarSeverity: "",
      isAppliedFilter: false,
      isB2BActive: false,
      // Notes Dialog State
      notesDialogOpen: false,
      currentOrderIdForNotes: null,
      tempNotes: "",
      isUpdatingNotes: false,
      mobileServiceRequests: [],
      driverMenuAnchor: null,
      driverMenuLeg: "pickup",
      assignableDrivers: [],
      assignableDriversLoading: false,
      currentDrivers: { pickup: null, delivery: null },
      assigningDriverId: null,
      contactInfoAnchor: null,
      contactInfoData: null,
      contactInfoTitle: "Customer",
      isMobileRequestsLoading: false,
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
      mobileRequestDetailLoading: false,
      isAcceptingMobileRequest: false,
      isStartingPickup: false,
      pickupActionDialogOpen: false,
      pickupActionType: "",
      pickupActionNotes: "",
      pickupActionImages: [],
      isSubmittingPickupAction: false,
      isMarkingInStore: false,
      isAcceptingDelivery: false,
      isStartingDelivery: false,
      eventsExpanded: false
      // Customizable Area End
    };
  }

  async receive(from: string, message: Message) {
    if (getName(MessageEnum.RestAPIResponceMessage) === message.id) {
      const apiRequestCallId = message.getData(getName(MessageEnum.RestAPIResponceDataMessage));
      const responseJson = message.getData(getName(MessageEnum.RestAPIResponceSuccessMessage));

      // Customizable Area Start
      this.getSectionListApiCallResponse(apiRequestCallId, responseJson);

      this.handlePaymentAllMethodResponse(apiRequestCallId,responseJson);

      this.sendToDriverApiCallResponse(apiRequestCallId, responseJson);

      this.getDriverReceiptApiCallResponse(apiRequestCallId, responseJson);

      this.updateStatusToCleanApiCallResponse(apiRequestCallId, responseJson);

      this.handleEmployeeListApiCallResponse(apiRequestCallId, responseJson);

      this.updateStatusToReceivedApiCallResponse(
        apiRequestCallId,
        responseJson
      );

      this.updateStatusToDeliveredApiCallResponse(
        apiRequestCallId,
        responseJson
      );

      this.updateStatusToAnyApiCallResponse(
        apiRequestCallId,
        responseJson
      );

      this.updateStatusToDeadStockApiCallResponse(
        apiRequestCallId,
        responseJson
      );

      this.handelGetOrderResponse(apiRequestCallId, responseJson);

      this.handleServiceSuggestionResponse(apiRequestCallId, responseJson);

      this.handelStoreResponse(apiRequestCallId, responseJson);

      this.handelCallIdResponse(apiRequestCallId, responseJson);

      this.handleMobileServiceRequestsResponse(apiRequestCallId, responseJson);
      this.handleMobileRequestDetailResponse(apiRequestCallId, responseJson);
      this.handleAcceptMobileRequestResponse(apiRequestCallId, responseJson);
      this.handleStartPickupResponse(apiRequestCallId, responseJson);
      this.handlePickupActionResponse(apiRequestCallId, responseJson);
      this.handleMarkInStoreResponse(apiRequestCallId, responseJson);
      this.handleAssignableDriversResponse(apiRequestCallId, responseJson);
      this.handleAssignDriverResponse(apiRequestCallId, responseJson);
      this.handleAcceptDeliveryResponse(apiRequestCallId, responseJson);
      this.handleStartDeliveryResponse(apiRequestCallId, responseJson);
      this.handleLocationResponse(apiRequestCallId, responseJson);

      this.handleGetOrderDetailResponse(apiRequestCallId, responseJson);

      this.handleGetOrderItemsResponse(apiRequestCallId, responseJson)

      this.handleCreditNoteResponse(message);

      this.handleReGenerateInvoiceResponse(
        apiRequestCallId,
        responseJson
      );

      this.handleRawInvoiceDataResponse(
        apiRequestCallId,
        responseJson
      )

      this.handleScanOrderResponse(
        apiRequestCallId,
        responseJson
      )

      if (apiRequestCallId === this.getCustomerNameCallId) {
        this.setState({ customerFilterNameList: responseJson.filter_names });
      } else if (apiRequestCallId === this.getCustomerNumberCallId) {
        this.setState({ customerFilterNumberList: responseJson.customer });
      } else if (apiRequestCallId === this.updateEmployeeCurrentStoreApiId) {
        this.state.userRefresh();
      } else if (apiRequestCallId === this.updateOrderNotesCallId) {
        this.handleUpdateNotesResponse(responseJson);
      }
      // Customizable Area End
    }

    // Customizable Area Start
    this.receivePrintSettings(message)
    this.fetchDataFromLayout(message)
    this.fetchSearchTextData(message)
    this.receiveDataFromHeader(message)
    if (
      message.id === getCustomEnumName(CustomEnums.DataForRedirectionFromNotification)
    ) {
      const {
        order_number,
        internal_status,
        store_id
      } = message.properties.orderData;
      
      // set tab id based on internal status
      let tabStatusList = [
        "coming_to_store",
        "in_store",
        "cleaning",
        "ready",
        "delivered",
        "send_to_deadstock",
        "cancelled"
      ];

      const findTabindex = tabStatusList.findIndex((tabStatus) => tabStatus === internal_status);

      this.setState({
        searchText: order_number,
        tabId: findTabindex,
        selectedTab: "Plant Cleaning",
        storeId: store_id
      }, () => {
        this.getOrdersList()
    })
    }

    if (message.id === getCustomEnumName(CustomEnums.ReceiptPrinterSettingUpdated)) {
      this.handleUpdatePrinterSetting()
    }
    // Customizable Area End
  }

  async componentDidMount() {
    super.componentDidMount();
    // Customizable Area Start
    this.handleStorageFilter();
    // Customizable Area End
  }

  async componentWillUnmount() {
    // Customizable Area Start
    this.stopLocationPolling();
    // Customizable Area End
  }

  // Customizable Area Start

  receiveDataFromHeader = (message: Message) => {
    if (message.id === getName(MessageEnum.BroadcastNavbarDataMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.BroadcastNavbarData)
      );
      if (recievedData.singleStoreID) {
        let NotificationNavigation = localStorage.getItem("NotificationNavigation")
        if(NotificationNavigation){
          return localStorage.removeItem("NotificationNavigation")
        }
        this.handleStoreId({ id: recievedData.singleStoreID, option: recievedData.singleStoreName });
        this.handleTabChange(1);
      }
    }
  }

  fetchSearchTextData = (message: Message) => {
    if (message.id === getName(MessageEnum.SearchTextMessage)) {
      const recievedData = message.getData(
        getName(MessageEnum.SearchMessageText)
      );
      if (recievedData) {
        this.handleSearch(recievedData.searchText)
      }
    }
  }

  fetchDataFromLayout = (message: Message) => {
    if (message.id === getName(MessageEnum.LayoutDataMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.LayoutMessageData)
        );
        if (recievedData.userContext) {
            this.setState({ isDrawerOpen: recievedData.isDrawerOpen})
            this.handleUserChange(recievedData.userContext)
        }
    }
  }

  receivePrintSettings = (message: Message) => {
    if (message.id === getName(MessageEnum.PrintSettingsMessage)) {
        const recievedData = message.getData(
            getName(MessageEnum.PrintSettngsData)
        );
        if (recievedData) {
          console.log(recievedData,"recievedDatarecievedData")
            this.setState({ printerSetting: recievedData.receiptPrinterSetting})
        }
    }
  }

  setDropdownList = () => {
    const { permissionStatus } = this.state;
    
    const dropdownList = [
      {
        label: "Send To Driver",
        value: "Send to driver",
        tabId: 1,
        permission: permissionStatus.sendToDriverAction
      },
      {
        label: "Received", 
        value: "Received",
        tabId: 0,
        permission: true
      },
      {
        label: "Run Audits",
        value: "Run audits",
        tabId: 3,
        permission: true
      },
      {
        label: "View Audits",
        value: "View audits",
        tabId: 3,
        permission: true
      },
      {
        label: "Delivered",
        value: "Delivered",
        tabId: 3,
        permission: true
      },
      {
        label: "Send to Dead Stocks",
        value: "Send to dead stocks",
        tabId: 3,
        permission: permissionStatus.sendToDeadStockAction
      },
      { label: "Ready", value: "ready", tabId: 1,permission:false },
      { label: "Delivered", value: "delivered", tabId: 1,permission:false },
      { label: "Send to Dead Stocks", value: "send_to_deadstock", tabId: 1,permission:false },

      { label: "Store", value: "in_store", tabId: 2,permission:true },
      { label: "Ready", value: "ready", tabId: 2,permission:permissionStatus.cleanAction },
      { label: "Delivered", value: "delivered", tabId: 2,permission:true },
      { label: "Send to Dead Stocks", value: "send_to_deadstock", tabId: 2,permission:permissionStatus.sendToDeadStockAction },

      { label: "Store", value: "in_store", tabId: 3, permission:permissionStatus.storeDropdownAction },
      { label: "Cleaning", value: "cleaning", tabId: 3, permission:permissionStatus.cleaningDropdownAction },

      { label: "Store", value: "in_store", tabId: 4,permission:permissionStatus.storeDropdownAction },
      { label: "Ready", value: "ready", tabId: 4 ,permission:permissionStatus.readyDropdownAction },
      { label: "Send to Dead Stocks", value: "send_to_deadstock", tabId: 4 ,permission:permissionStatus.sendToDeadStockAction },
      { label: "Cleaning", value: "cleaning", tabId: 4, permission:permissionStatus.cleaningDropdownAction },

      { label: "Store", value: "in_store", tabId: 5, permission:true },
      { label: "Ready", value: "ready", tabId: 5, permission:true },
      { label: "Delivered", value: "delivered", tabId: 5, permission:true },
      { label: "Cleaning", value: "cleaning", tabId: 5, permission:true }
    ]
    this.setState({
      dropDownList: dropdownList
    })
  }

  handelCallIdResponse(
    apiRequestCallId: string,
    responseJson: { data: []; meta: {} }
  ) {
    if (apiRequestCallId !== this.getCallId) return;

    this.savedRawPrintDatasMap.clear()
    if (responseJson && responseJson.data && responseJson.data.length) {
      const array:IOrderData[] = responseJson?.data?.map((item: IOrderData) => ({
        ...item,
        checked: false,
      }));
      let tabId = sortCondition(this.state.searchResult,TAB_STATUS_LIST.indexOf(array[0].attributes.internal_status),this.state.tabId)
      this.setState({
        ordersList: array as IOrderData[],
        orderMetaData: { ...responseJson.meta },
        isLoadingOrderList: false,
        searchResult: false,
        tabId: tabId as number
      });
    } else this.setState({ ordersList: [], orderMetaData: {} });
  }

  handleMobileServiceRequestsResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.getMobileRequestsCallId) return;

    this.setState({ isMobileRequestsLoading: false, isLoadingOrderList: false });
    // API returns nested data.data structure
    const requestsData = responseJson?.data?.data || responseJson?.data;
    const meta = responseJson?.meta || {};
    if (requestsData && Array.isArray(requestsData) && requestsData.length > 0) {
      this.setState({
        mobileServiceRequests: requestsData,
        orderMetaData: { ...meta },
      });
    } else {
      this.setState({ mobileServiceRequests: [], orderMetaData: meta });
    }
  }

  getMobileRequestDetail = (id: string | number) => {
    this.setState({ mobileRequestDetailOpen: true, mobileRequestDetailLoading: true, mobileRequestDetailData: null, eventsExpanded: false });
    const requestMessage = MakeApiMessage({
      url: `bx_block_order_management/admin_mobile_service_requests/${id}`,
      method: "GET",
    });
    this.getMobileRequestDetailCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleMobileRequestDetailResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.getMobileRequestDetailCallId) return;
    this.setState({ mobileRequestDetailLoading: false });
    if (responseJson?.data) {
      this.setState({ mobileRequestDetailData: responseJson.data });
      this.evaluateLocationPolling(responseJson.data);
    }
  }

  closeMobileRequestDetail = () => {
    this.setState({ mobileRequestDetailOpen: false, mobileRequestDetailData: null, eventsExpanded: false });
  };

  toggleEventsExpanded = () => {
    this.setState((prev) => ({ eventsExpanded: !prev.eventsExpanded }));
  };

  openContactInfo = (
    event: React.MouseEvent<HTMLElement>,
    contactInfoTitle: string,
    contact: IContactInfo
  ) => {
    this.setState({
      contactInfoAnchor: event.currentTarget,
      contactInfoData: contact,
      contactInfoTitle,
    });
  };

  closeContactInfo = () => {
    this.setState({ contactInfoAnchor: null, contactInfoData: null });
  };

  acceptMobileRequest = (id: string | number) => {
    this.setState({ isAcceptingMobileRequest: true });
    const requestMessage = MakeApiMessage({
      url: `mobile/bx_block_order_management/driver_mobile_service_requests/${id}/accept`,
      method: "PUT",
    });
    this.acceptMobileRequestCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleAcceptMobileRequestResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.acceptMobileRequestCallId) return;
    this.setState({ isAcceptingMobileRequest: false });
    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Failed to accept request",
        snackBarSeverity: "error",
      });
      return;
    }
    this.setState({
      snackbarMessage: "Request accepted successfully",
      snackBarSeverity: "success",
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  startPickup = (id: string | number, deliveryAddress: any) => {
    if (deliveryAddress?.latitude && deliveryAddress?.longitude) {
      this.openMapNavigation(deliveryAddress.latitude, deliveryAddress.longitude);
    }
    this.setState({ isStartingPickup: true });
    this.pendingStartPickupRequestId = String(id);
    const requestMessage = MakeApiMessage({
      url: `mobile/bx_block_order_management/driver_mobile_service_requests/${id}/start_pickup`,
      method: "PUT",
    });
    this.startPickupCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleStartPickupResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.startPickupCallId) return;
    this.setState({ isStartingPickup: false });
    if (responseJson?.errors || responseJson?.error) {
      this.pendingStartPickupRequestId = null;
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Failed to start pickup",
        snackBarSeverity: "error",
      });
      return;
    }
    const requestId =
      String(responseJson?.data?.id ?? this.pendingStartPickupRequestId ?? "");
    this.pendingStartPickupRequestId = null;
    if (requestId) {
      this.startLocationPolling(requestId);
    }
    this.setState({
      snackbarMessage: "Pickup started successfully",
      snackBarSeverity: "success",
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  openPickupActionDialog = (type: "picked_up" | "pickup_rejected" | "customer_unavailable" | "delivered") => {
    this.setState({
      pickupActionDialogOpen: true,
      pickupActionType: type,
      pickupActionNotes: "",
      pickupActionImages: [],
    });
  };

  closePickupActionDialog = () => {
    this.setState({
      pickupActionDialogOpen: false,
      pickupActionType: "",
      pickupActionNotes: "",
      pickupActionImages: [],
    });
  };

  setPickupActionNotes = (notes: string) => {
    this.setState({ pickupActionNotes: notes });
  };

  setPickupActionImages = (files: FileList | null) => {
    if (!files) return;
    this.setState({ pickupActionImages: Array.from(files) });
  };

  submitPickupAction = (id: string | number) => {
    const { pickupActionType, pickupActionNotes, pickupActionImages } = this.state;
    if (!pickupActionType) return;
    const notesRequired = pickupActionType === "pickup_rejected" || pickupActionType === "customer_unavailable";
    if (notesRequired && !pickupActionNotes.trim()) {
      this.setState({
        snackbarMessage: "Notes are required for this action",
        snackBarSeverity: "error",
      });
      return;
    }
    const formData = new FormData();
    if (pickupActionNotes.trim()) {
      formData.append("notes", pickupActionNotes.trim());
    }
    pickupActionImages.forEach((file) => {
      formData.append("images[]", file);
    });
    this.setState({ isSubmittingPickupAction: true });
    const requestMessage = MakeApiMessage({
      url: `mobile/bx_block_order_management/driver_mobile_service_requests/${id}/${pickupActionType}`,
      method: "PUT",
      body: formData,
      isHeader: true,
    });
    this.pickupActionCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handlePickupActionResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.pickupActionCallId) return;
    this.setState({ isSubmittingPickupAction: false });
    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Action failed",
        snackBarSeverity: "error",
      });
      return;
    }
    this.stopLocationPolling();
    const successMap: { [key: string]: string } = {
      picked_up: "Marked as picked up",
      pickup_rejected: "Pickup rejected",
      customer_unavailable: "Customer unavailable recorded",
      delivered: "Marked as delivered",
    };
    this.setState({
      snackbarMessage: successMap[this.state.pickupActionType] || "Action completed",
      snackBarSeverity: "success",
      pickupActionDialogOpen: false,
      pickupActionType: "",
      pickupActionNotes: "",
      pickupActionImages: [],
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  navigateToOrderCreation = (request: any) => {
    const attrs = request?.attributes;
    if (attrs?.customer) {
      window.localStorage.setItem(
        "mobileServiceRequestData",
        JSON.stringify({
          mobile_service_request_id: request.id,
          customer_phone: attrs.customer.phone_number,
          customer_id: attrs.customer.id,
        })
      );
    }
    window.location.assign("/StoreManage-OrderCreation");
  };

  markInStore = (id: string | number) => {
    this.setState({ isMarkingInStore: true });
    const requestMessage = MakeApiMessage({
      url: `bx_block_order_management/admin_mobile_service_requests/${id}/mark_in_store`,
      method: "PUT",
    });
    this.markInStoreCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  openDriverMenu = (event: React.MouseEvent<HTMLElement>, driverMenuLeg: DriverLeg) => {
    const requestId = this.state.mobileRequestDetailData?.id;
    this.setState({
      driverMenuAnchor: event.currentTarget,
      driverMenuLeg,
      assignableDrivers: [],
      assignableDriversLoading: true,
    });

    const requestMessage = MakeApiMessage({
      url: `bx_block_order_management/admin_mobile_service_requests/${requestId}/assignable_drivers`,
      method: "GET",
    });
    this.getAssignableDriversCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  closeDriverMenu = () => {
    this.setState({ driverMenuAnchor: null });
  };

  handleAssignableDriversResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.getAssignableDriversCallId) return;

    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        assignableDriversLoading: false,
        assignableDrivers: [],
        snackbarMessage:
          toString(responseJson.errors || responseJson.error) ||
          "Failed to load drivers",
        snackBarSeverity: "error",
      });
      return;
    }

    this.setState({
      assignableDriversLoading: false,
      assignableDrivers: responseJson?.data || [],
      currentDrivers: {
        pickup: responseJson?.current_drivers?.pickup ?? null,
        delivery: responseJson?.current_drivers?.delivery ?? null,
      },
    });
  }

  assignDriver = (driverId: number) => {
    const requestId = this.state.mobileRequestDetailData?.id;
    this.setState({ assigningDriverId: driverId });

    const requestMessage = MakeApiMessage({
      url: `bx_block_order_management/admin_mobile_service_requests/${requestId}/assign_driver`,
      method: "PUT",
      body: JSON.stringify({
        driver_id: driverId,
        leg: this.state.driverMenuLeg,
      }),
    });
    this.assignDriverCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleAssignDriverResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.assignDriverCallId) return;
    this.setState({ assigningDriverId: null });

    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        snackbarMessage:
          toString(responseJson.errors || responseJson.error) ||
          "Failed to assign driver",
        snackBarSeverity: "error",
      });
      return;
    }

    const leg = this.state.driverMenuLeg;
    this.setState({
      driverMenuAnchor: null,
      snackbarMessage: `${leg === "delivery" ? "Delivery" : "Pickup"} driver updated`,
      snackBarSeverity: "success",
    });

    // Re-read the request so both driver rows reflect what was saved.
    const requestId = this.state.mobileRequestDetailData?.id;
    if (requestId) this.getMobileRequestDetail(requestId);
    this.getMobileServiceRequests();
  }

  handleMarkInStoreResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.markInStoreCallId) return;
    this.setState({ isMarkingInStore: false });
    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Failed to mark as reached store",
        snackBarSeverity: "error",
      });
      return;
    }
    this.setState({
      snackbarMessage: "Marked as reached store",
      snackBarSeverity: "success",
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  acceptDelivery = (id: string | number) => {
    this.setState({ isAcceptingDelivery: true });
    const requestMessage = MakeApiMessage({
      url: `mobile/bx_block_order_management/driver_mobile_service_requests/${id}/accept_delivery`,
      method: "PUT",
    });
    this.acceptDeliveryCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleAcceptDeliveryResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.acceptDeliveryCallId) return;
    this.setState({ isAcceptingDelivery: false });
    if (responseJson?.errors || responseJson?.error) {
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Failed to accept delivery",
        snackBarSeverity: "error",
      });
      return;
    }
    this.setState({
      snackbarMessage: "Delivery accepted",
      snackBarSeverity: "success",
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  startDelivery = (id: string | number, deliveryAddress: any) => {
    if (deliveryAddress?.latitude && deliveryAddress?.longitude) {
      this.openMapNavigation(deliveryAddress.latitude, deliveryAddress.longitude);
    }
    this.setState({ isStartingDelivery: true });
    this.pendingStartDeliveryRequestId = String(id);
    const requestMessage = MakeApiMessage({
      url: `mobile/bx_block_order_management/driver_mobile_service_requests/${id}/start_delivery`,
      method: "PUT",
    });
    this.startDeliveryCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleStartDeliveryResponse(apiRequestCallId: string, responseJson: any) {
    if (apiRequestCallId !== this.startDeliveryCallId) return;
    this.setState({ isStartingDelivery: false });
    if (responseJson?.errors || responseJson?.error) {
      this.pendingStartDeliveryRequestId = null;
      this.setState({
        snackbarMessage: toString(responseJson.errors || responseJson.error) || "Failed to start delivery",
        snackBarSeverity: "error",
      });
      return;
    }
    const requestId =
      String(responseJson?.data?.id ?? this.pendingStartDeliveryRequestId ?? "");
    this.pendingStartDeliveryRequestId = null;
    if (requestId) {
      this.startLocationPolling(requestId);
    }
    this.setState({
      snackbarMessage: "Delivery started",
      snackBarSeverity: "success",
      mobileRequestDetailOpen: false,
      mobileRequestDetailData: null,
    });
    this.getMobileServiceRequests();
  }

  evaluateLocationPolling = (request: any) => {
    if (!request) return;
    const status = request?.attributes?.status;
    const id = String(request?.id ?? request?.attributes?.id ?? "");
    if (!id) return;
    if (
      status === "driver_on_the_way_pickup" ||
      status === "driver_on_the_way_delivery"
    ) {
      this.startLocationPolling(id);
    } else {
      this.stopLocationPolling();
    }
  };

  startLocationPolling = (requestId: string) => {
    if (
      this.locationPollingIntervalId &&
      this.locationPollingRequestId === requestId
    ) {
      return;
    }
    this.stopLocationPolling();
    this.locationPollingRequestId = requestId;
    this.postCurrentLocation(requestId);
    this.locationPollingIntervalId = setInterval(() => {
      this.postCurrentLocation(requestId);
    }, 15000);
  };

  stopLocationPolling = () => {
    if (this.locationPollingIntervalId) {
      clearInterval(this.locationPollingIntervalId);
      this.locationPollingIntervalId = null;
    }
    this.locationPollingRequestId = null;
  };

  postCurrentLocation = (requestId: string) => {
    if (typeof navigator === "undefined" || !navigator.geolocation) return;
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const requestMessage = MakeApiMessage({
          url: `mobile/bx_block_order_management/driver_mobile_service_requests/${requestId}/location`,
          method: "PUT",
          body: JSON.stringify({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }),
        });
        this.postLocationMessageId = requestMessage.messageId;
        runEngine.sendMessage(requestMessage.id, requestMessage);
      },
      () => {},
      { enableHighAccuracy: true, timeout: 5000, maximumAge: 0 }
    );
  };

  handleLocationResponse = (apiRequestCallId: string, responseJson: any) => {
    if (apiRequestCallId !== this.postLocationMessageId) return;
    if (!responseJson) return;
    const errors = responseJson?.errors;
    if (Array.isArray(errors) && errors.length > 0) {
      const message = String(errors[0] || "");
      if (message.includes("Location updates are throttled")) return;
      this.stopLocationPolling();
    }
  };

  openMapNavigation = (latitude: string | number, longitude: string | number) => {
    window.open(
      `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`,
      "_blank"
    );
  };

  formatMobileRequestStatus = (status: string) => {
    return status
      .split("_")
      .map((word: string) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  formatMobileRequestDate = (dateStr: string | null) => {
    if (!dateStr) return "--";
    const date = new Date(dateStr);
    return date.toLocaleString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  getMobileStatusColor = (status: string) => {
    const colorMap: { [key: string]: { bg: string; color: string } } = {
      pending: { bg: "#FEF3C7", color: "#92400E" },
      accepted: { bg: "#D1FAE5", color: "#065F46" },
      pickup_in_progress: { bg: "#DBEAFE", color: "#1E40AF" },
      picked_up: { bg: "#E0E7FF", color: "#3730A3" },
      order_created: { bg: "#EDE9FE", color: "#5B21B6" },
      ready: { bg: "#D1FAE5", color: "#065F46" },
      out_for_delivery: { bg: "#FEF3C7", color: "#92400E" },
      delivered: { bg: "#D1FAE5", color: "#065F46" },
      cancelled: { bg: "#FEE2E2", color: "#991B1B" },
    };
    return colorMap[status] || { bg: "#F3F4F6", color: "#374151" };
  };

  handelStoreResponse(apiRequestCallId: string, responseJson: { data?: {id: string; attributes: {store_name: string}}[] }) {
    if (apiRequestCallId === this.getStoreCallId) {
      const { storeList, storeListPageNo, storeId, storeName } = this.state
      let currentStore = storeList.find(store => store.id === storeId)
      if (storeId && !currentStore) {
        currentStore = {
          id: storeId,
          option: storeName
        }
      }
      const array = (responseJson?.data || []).map(item => ({id: item.id, option: item.attributes.store_name}))
      const newStoreList = storeListPageNo === 1 ? array: [...storeList, ...array]
      currentStore && newStoreList.unshift(currentStore)
      this.storeListEmptyFlag = array.length < 10
      this.setState({
          storeList: uniqBy(newStoreList, "id")
      });
    }
  }

  handleServiceSuggestionResponse(
    apiRequestCallId: string,
    responseJson: { filter_names: [] }
  ) {
    if (apiRequestCallId === this.getServicesSuggestion) {
      const list =
        responseJson?.filter_names?.map((value: string) => ({
          label: value,
          value: value,
        })) || [];
      const updatedFilters = this.state.filters.map((item: IFilter) => {
        if (item.title === "Services") item.options = list;
        return item;
      });
      this.setState({ filters: updatedFilters });
    }
  }

  formatDate(stringDate: string) {
    if (!stringDate) return "--";
    let date = new Date(stringDate);
    const dayValue = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Note: Months are 0-based, so we add 1
    const year = String(date.getFullYear());

    return `${dayValue}/${month}/${year}`;
  }
  
  handelGetOrderResponse(
    requestId: string,
    response: { data: { attributes: IOrder } }
  ) {
    if (this.getOrderMessageId === requestId) {
      if (response.data) {
        this.setState({ order: response.data });
        if (this.state.paymentClicked) {
          this.setState(
            {
              selectedOrders: [response.data as unknown as IOrderData],
              paymentModalVisible: false,
              unpaidDialogPopup: false,
              paymentClicked: false,
              order: null,
            },()=> this.handleSendToDelivered([response.data as unknown as IOrderData])
          );
        }
      }
    }
  }
  
  getEmployeeList() {
    const message = MakeApiMessage({
      method: "get",
      url: configJSON.employeeListApi + "&allow_access=true",
    });
    this.employeeListMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  updateEmployeeCurrentStore = (storeId: number) => {
    const header = {
      "Content-Type": configJSON.ordersApiContentType,
      token: localStorage.getItem("token"),
    };

    const bodyData = {
      store_id: storeId,
    };

    const messageEmp = new Message(getName(MessageEnum.RestAPIRequestMessage));

    messageEmp.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      configJSON.updateEmployeeCurrentStoreApi
    );
    messageEmp.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    messageEmp.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify(bodyData)
    );
    messageEmp.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpPutMethod
    );

    this.updateEmployeeCurrentStoreApiId = messageEmp.messageId;
    runEngine.sendMessage(messageEmp.id, messageEmp);
  };

  clearCustomerFilter = () => {
    let temp = [...this.state.filters];
    const indexValue = this.state.filters.findIndex(
      (item) => item.title === "Customer"
    );
    temp[indexValue].value = "";

    this.setState({ customerNumberValue: "", filters: [...temp] });
  }

  renderfilterCustomer = () => {
    let filterName = this.state.filters.find(
      (object: {title: string}) => object.title === "Customer"
    );
    return (
      <Box>
        <div
          style={{
            marginLeft: "24px",
            marginRight: "24px",
          }}
        >
          <p style={{ marginBottom: "16px" }}>Search Customer By</p>

          <>
            <div style={this.textLabelStyle}>{"Name"}</div>
            <AutoComplete
              freeSolo
              value={filterName?.value}
              disableClearable
              options={
                this.state.customerFilterNameList?.map(
                  (option: string) => option
                ) || []
              }
              onChange={(event, value) => {
                let tempFilters = [...this.state.filters];
                let indexValue = tempFilters.findIndex(
                  (object: {title: string}) => object.title === "Customer"
                );
                tempFilters[indexValue].value = value;
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                  style={this.textInputStyle}
                  variant='outlined'
                  type={"text"}
                  placeholder='Type to Select'
                  onChange={(event) => this.handleCustomerInputChange(event)}
                />
              )}
            />
          </>
          <p style={{ marginTop: "16px", marginBottom: "16px" }}>Or</p>
          <>
            <div
              style={{
                fontFamily: "Montserrat",
                color: "#000",
                lineHeight: "22px",
                fontWeight: 600,
                fontSize: "14px",
              }}
            >
              {"Number"}
            </div>
            <AutoComplete
              freeSolo
              value={this.state.customerNumberValue}
              disableClearable
              options={
                this.state.customerFilterNumberList?.map(
                  (option: FilterNumberResponse) => option.full_phone_number
                ) || []
              }
              onChange={(event, value) => {
                this.setState({ customerNumberValue: value });
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                    type: "search",
                  }}
                  style={{
                    marginTop: "4px",
                    height: "44px",
                    width: "190px",
                    fontFamily: "Montserrat !important",
                    marginBottom: "8px",
                  }}
                  variant='outlined'
                  type={"text"}
                  placeholder='Type to Select'
                  onChange={(event) => this.handleCustomerNumberInputChange(event)}
                />
              )}
            />
          </>
        </div>
      </Box>
    );
  };

  handleCustomerInputChange = (event: React.ChangeEvent<{value: string}>) => {
    const header = {
      "Content-Type": configJSON.applicationJsonContentType,
      token: localStorage.getItem("token"),
    };

    const apiUrl =
      configJSON.getCustomerNameDropdown + `?customer_name=${event.target.value}`;

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getCustomerNameCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiUrl
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };
  handleCustomerNumberInputChange = (event: React.ChangeEvent<{ value: string }>) => {
    const header = {
      "Content-Type": configJSON.applicationJsonContentType,
      token: localStorage.getItem("token"),
    };

    const apiUrl =
      configJSON.customerSearch + `?full_phone_number=${event.target.value}`;

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getCustomerNumberCallId = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiUrl
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };
  getStoreList = () => {
    const header = {
      "Content-Type": configJSON.applicationJsonContentType,
      token: localStorage.getItem("token"),
    };

    const searchQuery = this.state.storeSearchText ? `&filter_by[query]=${this.state.storeSearchText}` : "";

    const apiUrl =
      configJSON.getStoreListApi +
      "?dropdown=true&page_no=" +
      this.state.storeListPageNo + searchQuery;

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getStoreCallId = getDataMsg.messageId;
    this.storeListEmptyFlag = true;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiUrl
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.httpGetMethod
    );
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  handleTabChange = (tabIndex: number) => {
    this.setState(
      {
        tabId: tabIndex,
        showCheckBoxAndButton: false,
        selectedDropdownvalue: null,
        selectAllChecked: false,
        page: 1,
        selectedOrders: [],
      },
      () => {
        this.getOrdersList();
      }
    );
  };

  handleDropDownSelect = (event: React.ChangeEvent<{ value: unknown }>) => {
    const value = event.target.value as string;
    let temp = [...this.state.ordersList];
    temp = temp.map((tempValue: IOrderData) => ({
      ...tempValue,
      checked: false,
    }));

    let rewash;
    if (value === "rewash") {
      rewash = false;
    } else {
      rewash = !!value;
    }

    this.setState({
      showCheckBoxAndButton: rewash ? true : false,
      selectedDropdownvalue: value,
      ordersList: [...temp],
      selectAllChecked: false,
      selectedOrders: [],
    });
    value === "Send to driver" && this.getEmployeeList();
  };

  handleSelectAll = () => {
    let temp = [...this.state.ordersList];
    temp = temp.map((tempOrder: IOrderData) => ({
      ...tempOrder,
      checked: !this.state.selectAllChecked,
    }));
    this.setState({
      selectAllChecked: !this.state.selectAllChecked,
      ordersList: [...temp],
    });
  };

  handleCancel = () => {
    let temp = [...this.state.ordersList];
    temp = temp.map((tempOrder: IOrderData) => ({
      ...tempOrder,
      checked: false,
    }));
    this.setState({
      ordersList: [...temp],
      selectedDropdownvalue: "",
      showCheckBoxAndButton: false,
      selectAllChecked: false,
      selectedOrders: [],
      sendToDriverError: ""
    });
  };

  checkSelectDropdownValue = () => {
    const { selectedDropdownvalue } = this.state;
    if (selectedDropdownvalue === "Change status to clean") {
      return true;
    } else if (selectedDropdownvalue === "Received") {
      return true;
    } else if (selectedDropdownvalue === "Delivered") {
      return true;
    } else if (selectedDropdownvalue === "Send to dead stocks") {
      return true;
    } else if (selectedDropdownvalue === "rewash") {
      return true;
    }
    else if (selectedDropdownvalue === "ready" || selectedDropdownvalue === "in_store" 
    || selectedDropdownvalue === "delivered" || selectedDropdownvalue === "cleaning"
    || selectedDropdownvalue === "send_to_deadstock") {
      return true;
    } else {
      return false;
    }
  };

  renderButtonText = () => {
    const { selectedDropdownvalue } = this.state;
    if (selectedDropdownvalue === "rewash") {
      return "Rewash";
    } else {
      return "Change";
    }
  };

  handleSingleCheck = (value: string) => {
    const temp = [...this.state.ordersList];
    const indexValue = temp.findIndex((tempOrder: IOrderData) => tempOrder.id === value);
    temp[indexValue].checked = !temp[indexValue].checked;
    const isSelectAllCheckValue = temp.filter((tempOrder: IOrderData) => !tempOrder.checked);
    this.setState({ ordersList: [...temp] });
    if(isSelectAllCheckValue.length === 0){
      this.setState({ selectAllChecked: true });
    }else{
      this.setState({ selectAllChecked: false });
    }
  };

  handleSelectOrderToRewash = (value: string) => {
    const temp = [...this.state.ordersList];
    temp.forEach((tempOrder: IOrderData) => {
      if (tempOrder.id === value) {
        tempOrder.checked = !tempOrder.checked;
      } else {
        tempOrder.checked = false;
      }
    });
    this.setState({ ordersList: [...temp] });
  };

  handleIsActive = () => {
    this.setState({ popOverItemStatus: "Active" });
  };

  handleDrawerWidthChange = (width: number) => {
    this.setState({ drawerWidth: width });
  };
  handleOrderDetail = (data: IOrderData) => {
    this.setState({
      orderDetailPopup: true,
      orderData: data,
    });
  };
  handleDateFilterParam = () => {
    
    const dateFilter = this.state. filters.find((item) => item?.title === 'Due')?.value;
   
    let dateFilterQuery = '';

    if(dateFilter === 'specific'){
      const dateFilter = this.state.filters.find((item) => item?.title === 'Due')?.datevalue;
      if (dateFilter?.from && dateFilter?.to) {
        const dateRangeParams = getDateRangeForQuery(
          dateFilter.from,
          dateFilter.to
        )
        dateFilterQuery = `&filter_by[cleaning_due]=specific_dates${dateRangeParams.dateRangeQuery}` 
      }
    }else{
      dateFilterQuery =  dateFilter ? `&filter_by[cleaning_due]=${dateFilter}` : '';
    }
    return {dateFilterQuery}
   
  };
  handlePaymentFilterParam = () => {
    let paymentQuery: string = "";
    const paymentFilter = this.state.filters.find(
      (item) => item.title === "Payment Method"
    );
    if (paymentFilter && paymentFilter.value && paymentFilter.value.length) {
      paymentQuery = (paymentFilter.value as string[]).reduce(
        (param: string, varc: string) => param + "&filter_by[payment_method][]=" + varc,
        ""
      );
    }
    return paymentQuery
  }
  handlePaymentStatusFilterParam = () => {
    let filterPStatus = this.state.filters.find(
      (item) => item.title === "Payment Status"
    )?.value;
    filterPStatus = filterPStatus ? `&filter_by[payment_status]=${filterPStatus}` : "";
    return filterPStatus
  }
  getMobileServiceRequests = () => {
    // Without coming_to_store there is nothing to show, so don't call the API.
    if (!this.state.permissionStatus.comingToStoreAccess) {
      this.setState({ mobileServiceRequests: [], isMobileRequestsLoading: false });
      return;
    }

    const storeId = this.state.storeId ||
      this.state?.userData?.attributes?.employee_proifle?.data?.attributes?.store_management_id;

    this.setState({ isMobileRequestsLoading: true });

    // coming_to_store_all sees every store's requests, so the store filter is
    // omitted entirely rather than widened.
    const storeFilter = this.state.permissionStatus.comingToStoreAllAccess
      ? ""
      : `store_id=${storeId}&`;

    const requestMessage = MakeApiMessage({
      url: `bx_block_order_management/admin_mobile_service_requests?${storeFilter}page=${this.state.page}&per=${this.state.pageSize}`,
      method: "GET",
    });

    this.getMobileRequestsCallId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  getOrdersList = () => {
    // If coming_to_store tab, fetch mobile service requests instead
    if (this.state.tabId === 0) {
      this.getMobileServiceRequests();
      return;
    }

    const header = {
      "Content-Type": configJSON.apiContentType,
      token: window.localStorage.getItem(configJSON.token),
    };

    // customer number filters
    let filterCustomerNumber = this.state.customerNumberValue
      ? `&filter_by[customer_number]=${this.state.customerNumberValue}`
      : "";

    // customer filter
    let filterCustomer = this.state.filters.find(
      (item) => item.title === "Customer"
    )?.value;
    filterCustomer = filterCustomer
      ? `&filter_by[customer_name]=${filterCustomer}`
      : "";
    // service filter
    let filterService = this.state.filters.find(
      (item) => item.title === "Services"
    )?.value;
    filterService = filterService
      ? `&filter_by[service_name]=${filterService}`
      : "";

    // section filter
    let sectionQuery: string = "";
    const sectionFilter = this.state.filters.find(
      (item) => item.title === "Section"
    );
    if (sectionFilter && sectionFilter.value && sectionFilter.value.length) {
      sectionQuery = (sectionFilter.value as string[]).reduce(
        (param: string, varc: string) => param + "&filter_by[section_ids][]=" + varc,
        ""
      );
    }

    // order type filter
    let filterOrderType = this.state.filters.find(
      (item) => item.title === "Order Type"
    )?.value;
    filterOrderType = filterOrderType
      ? `&filter_by[request_type]=${filterOrderType}`
      : "";
    
    let paymentQueryParam = this.handlePaymentFilterParam()
   
    const { dateFilterQuery } = this.handleDateFilterParam()

    // status filter
    let filterStatus = this.state.filters.find(
      (item) => item.title === "Status"
    )?.value;
    filterStatus = filterStatus ? `&filter_by[status]=${filterStatus}` : "";

    let filterPStatus = this.handlePaymentStatusFilterParam()

    // tab change(status)
    let statusList = [
      "coming_to_store",
      "in_store",
      "cleaning",
      "ready",
      "delivered",
      "send_to_deadstock",
      "cancelled"
    ];
    let status = statusList[this.state.tabId];
    status = `&filter_by[status]=${status}`;
    const searchText = this.state.searchText
      ? `&filter_by[query]=${this.state.searchText}`
      : "";

    let apiEndPoint = this.getConditionBased(
      this.state.selectedTab == configJSON.carpetAndFurnitureTxt,
      configJSON.ordersPlantEndPoint,
      configJSON.newOrderListAPiEndPoint
    );

    let listEndPoint = `${apiEndPoint}?page_no=${this.state.page}&per_page=${
      this.state.pageSize
    }&store_id=${
      this.state.storeId ||
      this.state?.userData?.attributes?.employee_proifle?.data?.attributes
        ?.store_management_id
    }${sortStringCondition(this.state.searchResult,"",status)}${searchText}${
      this.state.query
    }${filterOrderType}
    ${filterStatus}${sectionQuery}${paymentQueryParam}${filterPStatus}${dateFilterQuery}${filterService}${filterCustomer}${filterCustomerNumber}${this.getConditionBased(
      this.state.selectedTab == configJSON.carpetAndFurnitureTxt,
      "&order_type=PlantCleaningOrder",
      ""
    )}`;
    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));
    this.getCallId = getDataMsg.messageId;

    this.setState({
      isLoadingOrderList: true
    })

    listEndPoint = listEndPoint.replace(/\s+/g, "");

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      listEndPoint
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  getSectionList() {
    const apiUrl = `${configJSON.getSectionListApiEndPoint
      }?token=${localStorage.getItem("token")}&dropdown=true`;

    const getAccount = apiCall({
      header: {},
      httpBody: {},
      url: apiUrl,
      httpMethod: configJSON.getSectionListApiMethod,
    });

    this.getSectionListApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }

  getSectionListApiCallResponse(apiRequestCallId: string, responseJson: {data: SectionListResponse[]}) {
    if (apiRequestCallId === this.getSectionListApiCallId) {
      // set date to state to avoid API call double times
      this.setState(() => ({
        sectionOptions: responseJson.data?.map(
          (item: {
            id: number;
            attributes: { section_name: string; active: boolean };
          }) => {
            return {
              id: item.id,
              label: item.attributes.section_name,
              active: item.attributes.active,
            };
          }
        ),
      }));

      // set section list for section options
      const seactionResults = responseJson.data?.map(
        (item: {
          id: number;
          attributes: { section_name: string; active: boolean };
        }) => {
          return {
            value: String(item.id),
            label: item.attributes.section_name,
          };
        }
      );
      const existingFilter = this.state.filters.find(
        (item) => item.title === "Section"
      );
      if (!existingFilter) return;
      existingFilter.options = seactionResults;
      this.setState({ filters: [...this.state.filters] });
    }
  };

  handlePaymentAllMethodResponse(
    apiRequestCallId: string,
    responseJson: { data: PaymentOptionResponse[] }
  ) {
    if (apiRequestCallId === this.getPaymentListApiCallId) {
      // set to state to avoid multiple API calls
      this.setState(() => ({
        paymentOptions: responseJson.data?.map(
          (item: PaymentOptionResponse) => {
            return {
              id: item.id,
              name: item.name,
              active: item.active,
            };
          }
        ),
      }));

      // set payment list for payment options
      const paymentResults = responseJson.data?.map(
        (item: PaymentOptionResponse) => {
          return {
            value: String(item.id),
            label: item.name,
          };
        }
      );
      const existingFilter = this.state.filters.find(
        (item) => item.title === "Payment Method"
      );
      if (!existingFilter) return;
      existingFilter.options = paymentResults;
      this.setState({ filters: [...this.state.filters] });
    }
  }
  
  getPaymentList() {
    const apiUrl = `${configJSON.getAllPaymentMethodEndPoint
      }?token=${localStorage.getItem("token")}&dropdown=true`;

    const getAccount = apiCall({
      header: {},
      httpBody: {},
      url: apiUrl,
      httpMethod: configJSON.getPaymentListApiMethod,
    });

    this.getPaymentListApiCallId = getAccount.messageId;
    runEngine.sendMessage(getAccount.id, getAccount);
  }
  sendToDriverApiCallResponse(apiRequestCallId: string, responseJson: SendToDriverResponse) {
    if (this.sendToDriverMessageId === apiRequestCallId) {
      if (this.scannedOrderId) {
        this.handleReceiveMessageForScanner(responseJson)
        responseJson.status === 200 && this.getDriverReceipt(responseJson)
        return;
      }
      if (!responseJson.errors) {
        this.setState({ isButtonLoading: false, selectedDropdownvalue: "" });
        this.getDriverReceipt(responseJson);
        this.handleTabChange(1);
      } else {
        this.setState({ sendToDriverError: responseJson.errors,  isButtonLoading: false });
      }
    }
  }

  getDriverReceiptApiCallResponse = (apiRequestCallId: string, responseJson?: {latest_receipt?: string}) => {
    if (this.getDriverReceiptMessageId === apiRequestCallId) {
      this.setState({showDriverReceiptConfirmation: true, driverReceipt: toString(responseJson?.latest_receipt), useRawPrinting: false})
    }
  }

  updateStatusToCleanApiCallResponse(apiRequestCallId: string, responseJson: {errors: string}) {
    if (this.updateStatusToCleanMessageId === apiRequestCallId) {
      if (!responseJson.errors) {
        this.setState({ selectedDropdownvalue: "" });
        this.handleTabChange(2);
      } else {
        this.setState({ sendToDriverError: responseJson.errors });
      }
    }
  }

  handleEmployeeListApiCallResponse(apiRequestCallId: string, responseJson: {data: EmployeeListResponse[] }) {
    if (this.employeeListMessageId === apiRequestCallId) {
      if (responseJson) {
        this.setState({
          driverList: responseJson.data.map((item: {attributes: {id: string, first_name: string}}) => {
            const { id, first_name } = item.attributes;
            return {
              value: id,
              label: first_name,
              tabId: this.state.tabId
            };
          }),
        });
      }
    }
  }

  updateStatusToReceivedApiCallResponse(
    apiRequestCallId: string,
    responseJson: {errors: string}
  ) {
    if (apiRequestCallId === this.updateStatusToReceivedMessageId) {
      if (this.scannedOrderId) {
        this.handleReceiveMessageForScanner(responseJson)
        return;
      }
      if (!responseJson.errors) {
        this.setState({ selectedDropdownvalue: "" });
        this.handleTabChange(1);
        this.componentDidMount();
      } else {
        this.setState({ sendToDriverError: responseJson.errors });
      }
    }
  }

  updateStatusToDeliveredApiCallResponse(
    apiRequestCallId: string,
    responseJson: {errors: string}
  ) {
    if (apiRequestCallId === this.updateStatusToDeliveredMessageId) {
      if (this.scannedOrderId) {
        this.handleReceiveMessageForScanner(responseJson)
        return;
      }
      if (!responseJson.errors) {
        this.setState({ selectedDropdownvalue: "" });
        this.handleTabChange(this.state.tabId);
      } else {
        this.setState({ sendToDriverError: responseJson.errors });
      }
    }
  }
  handleTAbChangeForAnyStatus(){
    const {selectedDropdownvalue,tabId} = this.state
    switch (selectedDropdownvalue) {
      case 'in_store':
        this.handleTabChange(tabId);
        break;
      case 'cleaning':
        this.handleTabChange(tabId);
        break;
      case 'ready':
        this.handleTabChange(tabId);
        break;
      case 'send_to_deadstock':
        this.handleTabChange(tabId);
        break;
      case 'delivered':
        this.handleTabChange(tabId);
        break;
    
      default:
        break;
    }
    this.setState({ selectedDropdownvalue: "" });
  }
  updateStatusToAnyApiCallResponse(
    apiRequestCallId: string,
    responseJson: {errors: string}
  ) {
    if (apiRequestCallId === this.updateStatusToAnyMessageId) {
      if (this.scannedOrderId) {
        this.handleReceiveMessageForScanner(responseJson)
        return;
      }
      if (!responseJson.errors) {
        this.handleTAbChangeForAnyStatus()
      } else {
        this.setState({ sendToDriverError: responseJson.errors });
      }
    }
  }

  updateStatusToDeadStockApiCallResponse(
    apiRequestCallId: string,
    responseJson: {errors: string}
  ) {
    if (apiRequestCallId === this.updateStatusToDeadStocksMessageId) {
      if (!responseJson.errors) {
        this.setState({ selectedDropdownvalue: "" });
        this.handleTabChange(this.state.tabId);
      } else {
        this.setState({ sendToDriverError: responseJson.errors });
      }
    }
  }

  handlePageChange = (page: number) => {
    this.setState({ page }, () => this.getOrdersList());
  };

  /**
   * Opens a driver's order in the POS cart to correct its items. It is a B2C
   * order, so the account type is switched back first — the cart reads the
   * catalogue for whichever type is active.
   */
  navigateToEditMobileOrder = (orderId: number | string) => {
    if (this.state.isB2BActive) {
      updateAccountType(false);
    }
    this.setState({ mobileRequestDetailOpen: false });
    this.props.navigation.navigate("EditQuickDrop", { editId: orderId });
  };

  handleEditClick = (rowOrderData: IOrderData) => {
    if (rowOrderData.attributes.is_quick_drop) {
      const isB2bOrder = rowOrderData.attributes.order_type === "B2bOrder"
      if (this.state.isB2BActive !== isB2bOrder) {
        updateAccountType(isB2bOrder)
      }
      this.props.navigation.navigate("EditQuickDrop", {
        editId: rowOrderData.attributes.id,
      });
    } else {
      this.setState({ orderData: rowOrderData, orderDetailPopup: true });
    }
  };

  handleFilterTabChange() {
    let filterStatus = this.state.filters.find(
      (item) => item.title === "Status"
    )?.value;

    switch (filterStatus) {
      case "cleaning":
        this.handleTabChange(2);
        break;
      case "ready":
        this.handleTabChange(3);
        break;
    }
  }

  handleSearch = (value: string) => {
    this.setState(
      {
        page: 1,
        searchText: value,
        searchResult: sortCondition(Boolean(value),true,false) as boolean
      },
      this.getOrdersList
    );
  };

  handleFilterChange = (filters: IFilter[]) => {
    // set filter applied value set
    if (checkIsFilterApplied(filters)) {
      localStorage.setItem("order_management_filter_value", JSON.stringify(filters));
    } else {
      localStorage.removeItem("order_management_filter_value");
    }

    this.setState(
      {
        filters,
        isAppliedFilter: checkIsFilterApplied(filters),
        page: 1,
      },
      () => {
        this.getOrdersList();
        this.handleFilterTabChange();
      }
    );
  };

  getServicesSuggestionFn = (query: string) => {
    let updated = this.state.filters.map((item: IFilter) => {
      if (item.title === "Services") item.value = query;
      return item;
    });

    this.setState({ filters: updated });

    const header = {
      "Content-Type": configJSON.applicationJsonContentType,
      token: localStorage.getItem("token"),
    };

    const apiUrl =
      configJSON.getCustomerNameDropdown + `?service_name=${query}`;

    const getDataMsg = new Message(getName(MessageEnum.RestAPIRequestMessage));

    this.getServicesSuggestion = getDataMsg.messageId;

    getDataMsg.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      apiUrl
    );
    getDataMsg.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    getDataMsg.addData(getName(MessageEnum.RestAPIRequestMethodMessage), "GET");
    runEngine.sendMessage(getDataMsg.id, getDataMsg);
  };

  handleQueryChange = (query: string) => {
    this.setState({ query }, () => this.getOrdersList());
  };

  sortingProps = {
    width: "",
    onQueryChange: (query: string) => this.handleQueryChange(`&${query}`),
    onChange: (sortingData: ISortingData) => this.setState({ sortingData }),
  };

  onClickSendToDriverSubmit(ordersToSend?: IOrderData[]) {
    let error = "";

    const { selectedDriver } = this.state;

    const selectedOrders = ordersToSend || this.state.selectedOrders

    if(!this.state.storeId) {
      error = "Please select a store"
    }
    this.setState({ sendToDriverError: error });
    if (error) { return; }

    if (!selectedOrders.length) {
      error = "Please select orders";
    } 

    this.setState({ sendToDriverError: error });

    if (error) {
      return;
    }

    if (!selectedDriver) {
      error = "Please select a driver";
    } 

    this.setState({ sendToDriverError: error, isScanningOrder: renderBooleanConditions(Boolean(this.scannedOrderId), !error, false) });

    if (error) {
      return;
    }
    
    this.setState({
      isButtonLoading: true
    });

      const order_ids = selectedOrders.map((item) => item.id);
      const requestMessage = MakeApiMessage({
        url: this.getConditionBased(
          this.state.selectedTab == configJSON.carpetAndFurnitureTxt,
          configJSON.homeCleaningOrderSendToDriverApi,
          configJSON.sendToDriverApi
        ) as string,
        method: configJSON.httpPostMethod,
        body: JSON.stringify({
          order_ids: order_ids,
          driver_account_id: selectedDriver,
          store_id: this.state.storeId,
        }),
      });
      this.sendToDriverMessageId = requestMessage.messageId;
      runEngine.sendMessage(requestMessage.id, requestMessage);
  }

  getDriverReceipt = (sendToDriverApiResponse: SendToDriverResponse) => {
    if (sendToDriverApiResponse.use_raw_printing_receipt) {
      this.setState({
        showDriverReceiptConfirmation: true,
        driverReceipt: sendToDriverApiResponse.data || "",
        useRawPrinting: true
      })
      return;
    }
    const requestMessage = MakeApiMessage({
      url: `${configJSON.employeeApi}/${this.state.selectedDriver}/get_drivers_receipt?store_id=${this.state.storeId}`,
      method: configJSON.httpGetMethod,
    });
    this.getDriverReceiptMessageId = requestMessage.messageId;
    this.send(requestMessage)
  } 

  getUnpaidOrders() {
    return this.state.selectedOrders.filter(
      (item: IOrderData) => item.attributes.paid_at == null
    );
  }

  handleSendToClean = (temp: Array<IOrderData>) => {
    const requestMessage = MakeApiMessage({
      url: configJSON.updateStatusToClean,
      method: configJSON.httpPostMethod,
      body: JSON.stringify({
        order_ids: temp.map((object: IOrderData) => object.id),
      }),
    });
    this.updateStatusToCleanMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleSendToRecieve = (temp: Array<IOrderData>) => {
    const paid_data = temp.filter(
      (item: IOrderData) => item.attributes.paid.length > 0
    );
    const requestMessage = MakeApiMessage({
      url: configJSON.updateStatusToReceived,
      method: configJSON.patchMethod,
      body: JSON.stringify({
        order_ids: paid_data.map((object: IOrderData) => object.id),
        store_id: this.state.storeId,
      }),
    });
    this.updateStatusToReceivedMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };
  handleGetDeliverUnpaid = (orderData:Array<IOrderData>) => {
    return orderData.filter(
      (item: IOrderData) => item.attributes.paid_at == null
    );
  }
  getOrderUnpaid(orderData:Array<IOrderData>) {
    
    let unpaidOrders = this.handleGetDeliverUnpaid(orderData);
    let order = unpaidOrders[0] || {};
    this.setState({ customerId: String(order.attributes.customer.id) });
    let message = MakeApiMessage({
      method: "GET",
      url: configJSON.getOrderApi + order.id,
    });
    this.getOrderMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }
  handleDeliverPaymentModalOpen = () => {
    const ordersLength = this.state.unpaidDialogDetail.length;

    if (ordersLength > 1) {
      this.setState({
        unPaidOrderError: configJSON.ListingPage.Strings.orderSinglePayment,
      });
      return;
    }

    this.setState({ paymentModalVisible: true, });
  };
  handleSendToDelivered = (temp: Array<IOrderData>) => {
    const is_unpaid_data = this.handleGetDeliverUnpaid(temp);

    if (is_unpaid_data.length > 0) {
      this.getOrderUnpaid(temp);
      this.setState({ unpaidDialogPopup: true,unpaidDialogDetail:is_unpaid_data });
    } else{
      const requestMessage = MakeApiMessage({
        url: configJSON.updateStatusToDelivered,
        method: configJSON.patchMethod,
        body: JSON.stringify({
          order_ids: temp.map((object: IOrderData) => object.id),
          store_id: this.state.storeId,
          status: "delivered",
        }),
      });
      this.updateStatusToDeliveredMessageId = requestMessage.messageId;
      runEngine.sendMessage(requestMessage.id, requestMessage);
    }
  };

  handleStatusChangetoAnyStatus = (temp: Array<IOrderData>, status: string) => {
    let url = configJSON.updateStatusToAnyStatus
    if(status === "ready" && this.state.tabId === 2){
      url = configJSON.updateStatusToAnyStatus + "?from_cleaning=true"
    }
      const requestMessage = MakeApiMessage({
        url: url,
        method: configJSON.httpPostMethod,
        body: JSON.stringify({
          order_ids: temp.map((object: IOrderData) => object.id),
          store_id: this.state.storeId,
          status: status,
        }),
      });
      this.updateStatusToAnyMessageId = requestMessage.messageId;
      runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  handleSendToDeadStocks = (temp: Array<IOrderData>) => {
    const requestMessage = MakeApiMessage({
      url: configJSON.updateStatusToDelivered,
      method: configJSON.patchMethod,
      body: JSON.stringify({
        order_ids: temp.map((object: IOrderData) => object.id),
        store_id: this.state.storeId,
        status: "send_to_deadstock",
      }),
    });
    this.updateStatusToDeadStocksMessageId = requestMessage.messageId;
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  updatePlantCarpetFurnitureStatus = (
    temp: Array<IOrderData>,
    status: string
  ) => {
    const requestMessage = MakeApiMessage({
      url: configJSON.updatePlantStoreStatusEndpoint,
      method: configJSON.httpPutMethod,
      body: JSON.stringify({
        order_ids: temp.map((object: IOrderData) => object.id),
        store_id: this.state.storeId,
        status: status,
      }),
    });
    switch (status) {
      case "ready":
        this.updateStatusToCleanMessageId = requestMessage.messageId;
        break;
      case "delivered":
        this.updateStatusToDeliveredMessageId = requestMessage.messageId;
        break;
      case "send_to_deadstock":
        this.updateStatusToDeadStocksMessageId = requestMessage.messageId;
        break;
    }
    runEngine.sendMessage(requestMessage.id, requestMessage);
  };

  selectedOrdersForSubmission = (orders?: IOrderData[]) => orders 
    || this.state.ordersList.filter(
      (order: IOrderData) => Boolean(order.checked)
    );

  onClickSendToCleanSubmit(orders?: IOrderData[]) {
    const { selectedDropdownvalue } = this.state;
    let error = "";
    let temp = this.selectedOrdersForSubmission(orders)

    if(!this.state.storeId && selectedDropdownvalue !== 'rewash') {
      error = "Please select a store"
    }

    this.setState({ sendToDriverError: error });

    if (error) {
      return;
    }

    if (!temp.length) {
      error = "Please select orders";
    }

    this.setState({ sendToDriverError: error });

    if (error) {
      return;
    }
    this.callStatusChangeAPI(selectedDropdownvalue, temp)
    switch (selectedDropdownvalue) {
      case "Change status to clean":
        if (this.state.selectedTab == configJSON.carpetAndFurnitureTxt) {
          this.updatePlantCarpetFurnitureStatus(temp, "ready");
        } else {
          this.handleSendToClean(temp);
        }
        break;
      case "Received":
        this.handleSendToRecieve(temp);
        break;
      case "Delivered":
        if (this.state.selectedTab == configJSON.carpetAndFurnitureTxt) {
          this.updatePlantCarpetFurnitureStatus(temp, "delivered");
        } else {
          this.handleSendToDelivered(temp);
        }
        break;
      case "Send to dead stocks":
        if (this.state.selectedTab == configJSON.carpetAndFurnitureTxt) {
          this.updatePlantCarpetFurnitureStatus(temp, "send_to_deadstock");
        }else {
          this.handleSendToDeadStocks(temp);
        }
        break;
      case "rewash":
        this.handleSendToRewash(temp);
        break;
    }
  }

  callStatusChangeAPI(selectedDropdownvalue: any, temp:Array<IOrderData>){
    if(selectedDropdownvalue === 'ready' || selectedDropdownvalue === 'in_store' ){
      this.handleStatusChangetoAnyStatus(temp,selectedDropdownvalue)
    }
    if(selectedDropdownvalue === 'delivered' || selectedDropdownvalue === 'cleaning'){
      this.handleStatusChangetoAnyStatus(temp,selectedDropdownvalue)
    }
    if(selectedDropdownvalue === 'send_to_deadstock'){
      this.handleStatusChangetoAnyStatus(temp,selectedDropdownvalue)
    }
  }

  getStatusOfOrder(status: string) {
    const { permissionStatus,ordersList } = this.state;
    switch (status) {
      case "coming_to_store":
        return "Received";
      case "cleaning":
        return permissionStatus.cleanAction ? "Clean" : "";
      case "ready":
        return "Delivered";
     case "delivered":

       const showRewash = ordersList.some(
        (order) =>
          order.attributes.internal_status === "delivered" &&
          order.attributes.order_type !== "GoldenPointsOrder" &&
          permissionStatus.rewashAction
      );

     return showRewash ? "Rewash" : "";
      default:
        return "";
    }
  }

  handleCleaningStatus(order: IOrderData) {
    if (order.attributes.plant_status_display_name != null) {
      return order.attributes.plant_status_display_name;
    } else {
      return "Cleaning";
    }
  }

  showStatusOnOrder(order: IOrderData) {
    switch (order.attributes.internal_status) {
      case "coming_to_store":
        return "New";
      case "in_store":
        return "In Store";
      case "cleaning":
        return this.handleCleaningStatus(order);
      case "ready":
        return "Ready";
      case "send_to_deadstock":
        return "Deadstock";
      case "delivered":
        return "Delivered";
      case "cancelled":
        return "Cancelled";
      default:
        return "---";
    }
  }

  showEditOrderButton(order: IOrderData) {
    switch (order.attributes.internal_status) {
      case "coming_to_store":
        return true;
      case "in_store":
        return true;
      default:
        return false;
    }
  }

  handleStatusChange = (rowData: IOrderData) => {
    const temp = [];
    temp.push(rowData);
    switch (this.getStatusOfOrder(rowData.attributes?.internal_status)) {
      case "Received":
        this.handleSendToRecieve(temp);
        break;
      case "Clean":
        if (this.state.selectedTab == configJSON.carpetAndFurnitureTxt) {
          this.updatePlantCarpetFurnitureStatus(temp, "ready");
        } else {
          this.handleSendToClean(temp);
        }
        break;
      case "Delivered":
        if (this.state.selectedTab == configJSON.carpetAndFurnitureTxt) {
          this.updatePlantCarpetFurnitureStatus(temp, "delivered");
        } else {
          this.handleSendToDelivered(temp);
        }
        break;
      case "Rewash":
        this.handleSendToRewash(temp);
        break;
    }
  };
  
  onSelectOrder(data: IOrderData) {
    const { selectedOrders } = this.state;
    const hasOrderId = selectedOrders.filter(
      (item: IOrderData) => item.id == data.id
    );
    this.setState({
      selectedOrders:
        hasOrderId.length > 0
          ? selectedOrders.filter((item: IOrderData) => item.id != data.id)
          : [...selectedOrders, data],
    });
  }

  checkIsOrderSelect(data: IOrderData) {
    const { selectedOrders } = this.state;
    const hasOrderId = selectedOrders.filter(
      (item: IOrderData) => item.id == data.id
    );
    if (hasOrderId.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  closeUnpaidDialog = () => {
    this.setState({ unpaidDialogPopup: false });
  };


  hideUnpaidOrderError() {
    this.setState({ unPaidOrderError: "" });
  }

  handlePaymentModalClose = () => {
    this.setState({ paymentModalVisible: false });
  };

  getOrder() {
    let unpaidOrders = this.getUnpaidOrders();
    let order = unpaidOrders[0] || {};
    this.setState({ customerId: String(order.attributes.account_id) });
    let message = MakeApiMessage({
      method: "GET",
      url: configJSON.getOrderApi + order.id,
    });
    this.getOrderMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handlePaymentDone = () => {
    this.setState({ paymentClicked: true });
    this.getOrderUnpaid(this.state.unpaidDialogDetail);
  };

  onSelectAllSendToDriver(rows: Array<IOrderData>) {
    const hiddenOrders = rows.filter(
      (item: IOrderData) => item.attributes.is_quick_drop
    ).length;

    const isSelectedAll =
      rows.length - hiddenOrders === this.state.selectedOrders.length &&
      this.state.selectedOrders.length > 0;

    const notQuickDropOrderIds = rows.filter(
      (item: IOrderData) => !item?.attributes?.is_quick_drop
    );

    this.setState({
      selectedOrders: isSelectedAll ? [] : notQuickDropOrderIds,
    });
  }

  onCloseDetailsScreen() {
    this.scannedOrderId = ""
    this.setState({ orderDetailPopup: !this.state.orderDetailPopup });
  }

  handelStoreDropdownScroll = (event: React.SyntheticEvent) => {
    if (this.storeListEmptyFlag) return;
    const listboxNode = event.currentTarget;

    const position = listboxNode.scrollTop + listboxNode.clientHeight;
    if (listboxNode.scrollHeight - position <= 1.3) {
      this.setState(
        (prev) => ({ storeListPageNo: prev.storeListPageNo + 1 }),
        () => {
          this.getStoreList();
        }
      );
    }
  };

  handleUserChange = async (userContext: IUserContext) => {
    const accountType = await getStorageData("accountType")
    const apiKey = customPermissionApiKey.orderPermission;
    const userData = userContext.user?.attributes.permission_groups;
    const value = checkForOrderPermissonStatus(apiKey, userData as unknown as Array<PermissionGroupArray>);
    const b2bPermission = checkForOrderPermissonStatus(customPermissionApiKey.b2BOrderPermission, userData as unknown as Array<PermissionGroupArray>)
    this.setState({
      permissionStatus: value,
      b2bPermissionStatus: b2bPermission,
      isB2BActive: accountType === "b2b"
    }, () => this.setDropdownList());

    const roleValue = userContext.user?.attributes?.role?.name
    const { store_id, store_name } = userContext?.user?.attributes?.employee_proifle?.data?.attributes?.store_management || {};
    this.setState({ 
      userData: userContext?.user as IMyUser,
      storeListPageNo: 1,
      storeId: toString(store_id),  
      storeName: toString(store_name)
     }, () => {
      this.getStoreList();
      if(roleValue === configJSON.storeKeeper){
        this.handleTabChange(1)
      }else{
        this.getOrdersList();
      }
    });
  }

  getConditionBased(flag: boolean, trueValue: unknown, falseValue: unknown) {
    return flag ? trueValue : falseValue;
  }

  checkTypeOfSell = () => {
    const { showCheckBoxAndButton, selectedDropdownvalue } = this.state;
    if (selectedDropdownvalue === "rewash" || showCheckBoxAndButton) {
      return "middle";
    } else {
      return "left";
    }
  };

  handleSendToRewash = (temp: Array<IOrderData>) => {
    const message = new Message(
      getCustomEnumName(CustomEnums.RewashModalOrderDataPass)
    );
    message.addData("ApiResponse", {
      temp: temp[0].attributes.id,
      handleTabChange: () =>  this.handleTabChange(this.state.tabId),
      typePlantCarpetFurnitureOrder: this.getConditionBased(
        this.state.selectedTab == configJSON.carpetAndFurnitureTxt,
        true,
        false
      ),
    });
    runEngine.sendMessage(message.id, message);

    navigateTo({
      props: this.props,
      screenName: "RewashOrderModal",
      raiseMessage: message,
    });
  };

  handleTabSeletion = (event: React.ChangeEvent<{}>, newValue: string) => {
    this.setState({ selectedTab: newValue }, () => this.getOrdersList());
  };

  handleCallSectionListAPI() {
    if (this.state.sectionOptions.length === 0) {
      this.getSectionList();
    }
  }
  handleCallPaymentListAPI() {
    if (this.state.paymentOptions.length === 0) {
      this.getPaymentList();
    }
  }
  
  filterAutoCompleteSuggestionListByTitle = (title: string, value: string) => {
    if (title === "Services") {
        this.getServicesSuggestionFn(value);
    }
  }

  openPrinterDialog = (orderItem: IOrderData) => {
    this.setState({ orderToPrint: orderItem })
  }
  closePrinterDialog = () => {
    this.setState({ orderToPrint: null })
  }
  handleSubmitPrintDialog = async (selectedType: string) => {
    if (selectedType === configJSON.PrintDialog.printRawReceipt) {
      if (this.state.orderToPrint) {
        this.getRawInvoiceData(this.state.orderToPrint.id)
      }
      return;
    }
    if (selectedType === configJSON.PrintDialog.printReceipt) {
    if (this.state.orderToPrint && this.state.orderToPrint?.attributes?.order_type == "GoldenPointsOrder") {
        if(this.state.orderToPrint?.attributes.invoice_receipt_pdf_url) {
          this.handlePrintReceipt(toString(this.state.orderToPrint.attributes.invoice_receipt_pdf_url))
        } else {
          this.handleReGenerateGoldenPointOrderInvoice(this.state.orderToPrint.attributes.id);
        }
      }else{
        if(this.state.orderToPrint?.attributes.invoice_receipt_pdf_url) {
          this.handlePrintReceipt(toString(this.state.orderToPrint.attributes.invoice_receipt_pdf_url))
        } else {
        this.handleReGenerateOrderInvoice(this.state.orderToPrint?.attributes?.id!);
        }
      }
    } else {
      const apiMessage = MakeApiMessage({
        method: "GET",
        url: configJSON.getOrderItemsList + this.state.orderToPrint?.id
      })
      this.getOrderItemsMessageId = apiMessage.messageId
      this.send(apiMessage)
    }
  }

  handleGetOrderItemsResponse(
    apiRequestCallId: string,
    response: { data? :  Array<{attributes: {tag_image: Array<{label_string: string}>}}>}
 ) {
    if(apiRequestCallId === this.getOrderItemsMessageId) {
      const responseData = response?.data || []
      const tagImages = responseData.flatMap(item => item.attributes.tag_image)
      this.handlePrintTag(tagImages)
    }
  }
  
  clearFilterPopOver = () => {
    this.setState({
      customerNumberValue: "",
    });
  }

  openFilterPopover = (event:React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    this.setState({
      filterAnchor: event.currentTarget,
    });
  }
  closeFilterPopover = () => {
    this.setState({ filterAnchor: undefined });
  }

  handleTableRowsPerPage = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ pageSize: event.target.value as number, page: 1 }, () =>
      this.getOrdersList()
    );
  }
  handleDrawer = (open: boolean) => {
    this.setState({ isDrawerOpen: open })
  }
  handleStoreId = (value: { id: string; option: string }) => {
    this.setState({ storeId: value.id, storeName: value.option });
  }
  handleSelectedDriver = (event: React.ChangeEvent<{ value: unknown }>) => {
    this.setState({ selectedDriver: event.target.value as string})
  }
  closeAlertError = () => {
    this.setState({ sendToDriverError: "" })
  }

  handleWindowSize = () => {
    const width = window.innerWidth;
    switch (true) {
      case (width <= 1024):
        return 38
      case (width <= 1280):
        return 40
      case (width <= 1366):
        return 40
      default:
        return 44
    }
  }

  handleStatusScroll = (isDrawerOpen: boolean) => {
    const width = window.innerWidth;
    if (width <= 1024 || (width <= 1560 && isDrawerOpen)) {
        return 'scrollable';
    } else {
        return 'fullWidth';
    }
  }

  getColumnsDynamicWidth = () => {
    const screenWidth = window.innerWidth;
    if (this.state.showCheckBoxAndButton ||  this.state.selectedDropdownvalue === "rewash") {
      switch (true) {
        case screenWidth <= 1024:
          return "30px 100px 90px 100px 100px 130px 40px 60px 60px 90px 1fr";
        case screenWidth <= 1280:
          return "40px 140px 136px 125px 120px 150px 50px 80px 80px 100px 1fr";
        case screenWidth <= 1366:
          return "45px 120px 120px 130px 130px 170px 55px 90px 90px 120px 1fr";
        default:
          return "50px 140px 140px 145px 140px 180px 80px 90px 90px 130px 1fr";
      }

    } else {
      switch (true) {
        case screenWidth <= 1024:
          return "100px 90px 100px 100px 130px 40px 60px 60px 90px 1fr";
        case screenWidth <= 1280:
          return "140px 140px 140px 120px 150px 50px 80px 80px 100px 1fr";
        case screenWidth <= 1366:
          return "140px 130px 135px 130px 170px 70px 80px 80px 120px 1fr";
        default:
          return "140px 140px 145px 140px 180px 80px 90px 90px 130px 1fr";
      }
    }
  };

  handleRawPrint = (payload: InvoiceRawData) => {
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_RECEIPT")
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), payload)
    this.send(printMessage)
    this.closePrinterDialog()
  }

    handleGoldenPointRawPrint = (payload: InvoiceRawData) => {
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "GOLDEN_POINT_PRINT_RECEIPT")
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), payload)
    this.send(printMessage)
    this.closePrinterDialog()
  }

    handleRedeemRawPrint = (payload: InvoiceRawData) => {
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_RECEIPT")
    printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), payload)
    this.send(printMessage)
    this.closePrinterDialog()
  }
  

  

  handlePrintReceipt = (receiptData: string | SalesPostedRawData) => {
    if (!receiptData) return this.setState({errorMessage : configJSON.NoReceiptMessage, orderToPrint: null})
    const {useRawPrinting} = this.state
    const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
    printMessage.addData(
      getCustomEnumName(CustomEnums.CustomReducerAction), 
      sortStringCondition(useRawPrinting, "PRINT_SALES_POSTED", "PRINT_FILE")
    )
    printMessage.addData(
      getCustomEnumName(CustomEnums.CustomReducerPayload), 
      useRawPrinting ? receiptData : {
      format: "pdf",
      data: receiptData
     })
    this.send(printMessage)
    this.closePrinterDialog()
  }

  handlePrintTag = (tagImages: Array<{label_string?: string}> | undefined) => {
    const tags = tagImages?.map((image) => image.label_string) || []
    const tagsToPrint = tags.filter(Boolean)
    if (tagsToPrint.length) {
      const printMessage = new Message(getCustomEnumName(CustomEnums.CustomActionReducers))
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerAction), "PRINT_TAGS")
      printMessage.addData(getCustomEnumName(CustomEnums.CustomReducerPayload), tagsToPrint)
      this.send(printMessage)
      this.closePrinterDialog()
    } else {
      this.setState({errorMessage: "No tags are available for this order."})
    }
  }

  closeCustomSnackbar = () => this.setState({errorMessage: "", snackbarMessage: "", snackBarSeverity: ""})

  handleSearchStore = (inputValue: string) => {
    if (inputValue === this.state.storeSearchText) return;
    this.setState({
      storeListPageNo: 1,
      storeSearchText: inputValue
    }, () => this.getStoreList())
  }

  debouncedStoreSearch = debounce(
    (newInputValue: string) => this.handleSearchStore(newInputValue),
    700,
    { maxWait: 2000 }
  );

  handleDriverReceiptDialog = (isContinue?: boolean) => 
    this.setState((prev) => ({
      showDriverReceiptConfirmation: false, 
      driverReceipt: isContinue ? prev.driverReceipt : ""
    }))
  
  handlePrintDriverReceipt = (selectedType: string) => {
    if (selectedType === configJSON.PrintDialog.printDriverReceipt) {
      this.handlePrintReceipt(this.state.driverReceipt)
      this.handleDriverReceiptDialog()
    }
  }

  handleDirectPaymentModalVisible = (rowData: IOrderData) => {
    this.getOrderDetail(rowData);
  }

  formatTaxPercentage = () => {
    const { selectedOrder } = this.state;

    if (!selectedOrder) return null;
    const decimalIndex = (selectedOrder.attributes as unknown as IOrder).tax_percentage.indexOf(".");
    const formattedTaxPercentage =
    (selectedOrder.attributes as unknown as IOrder).tax_percentage.slice(0, decimalIndex) + "%";
    return formattedTaxPercentage;
  };

  handleGetOrderDetailResponse(
    apiRequestCallId: string,
    response: { data : IOrderData }
 ) {
    if(apiRequestCallId === this.getOrderDetailMessageId) {
      if (response.data) {
        this.setState({
          selectedOrder: response.data,
          showDirectPaymentModal: true,
        });
        if (this.state.ispaymentClicked) {
          this.setState(
            {
              showDirectPaymentModal: false,
              ispaymentClicked: false,
              selectedOrder: null
            },
            () => { this.getOrdersList() }
          );
        }
      }
    }
  }
  getOrderDetail(rowData: IOrderData | null = null) {
    let order = rowData ? rowData : this.state.selectedOrder;
    this.setState({ customerId: String(order?.attributes.account_id) });

    let message = MakeApiMessage({
      method: "GET",
      url: configJSON.getOrderApi + order?.id,
    });
    this.getOrderDetailMessageId = message.messageId;
    runEngine.sendMessage(message.id, message);
  }

  handleSinglePaymentDone = () => {
    this.setState({ ispaymentClicked: true });
    this.getOrderDetail();
  };
  handleSinglePaymentClose = () => {
    this.setState({
      selectedOrder: null,
      showDirectPaymentModal: false
    })
  }

  handleUpdatePrinterSetting = () => this.setState({printerSetting: {...globalReceiptPrinterSetting}})

  showPrintButton = () => {
    const {tabId, printerSetting} = this.state
    const settingKey = TAB_SETTING_MAP[tabId]
    if (settingKey && !printerSetting?.[settingKey]) return false
    return true
  }

  toggleCreditNoteDialog = (item?: IOrderData) => {
    this.setState({
      creditNoteOrder: item,
      creditNotePresent: false,
      creditNoteReceipt: "",
      isCreditNoteDialogOpen: !this.state.isCreditNoteDialogOpen,
      hidden: true,
    });
    item && this.getCreditNoteDetailApi(item.id);
  };

  getCreditNoteDetailApi(orderId?: string) {
    this.setState({
      openCrediNoteModalLoader: true,
    });
    const message = MakeApiMessage({
      url: configJSON.getCreditNoteEndpoint + orderId,
      method: "GET",
    });
    this.getCreditNoteMessageId = message.messageId;
    this.send(message);
  }


  createCreditNoteApiCall() {
    const { addNote, creditNoteOrder } = this.state;
    this.setState({creditLoader:true})
    const message = MakeApiMessage({
      url: configJSON.createCreditNoteEndPoint,
      method: "POST",
      body: JSON.stringify({
        notes: addNote,
        order_id: creditNoteOrder?.id,
      }),
    });
    this.getCreateCreditNoteMessageId = message.messageId;
    this.send(message);
  }

  handleCreditNoteResponse(message: Message) {
    const requestId = message.getData(
      getName(MessageEnum.RestAPIResponceDataMessage)
    );
    const creditNoteResponse = message.getData(
      getName(MessageEnum.RestAPIResponceSuccessMessage)
    );

    if (requestId == this.getCreateCreditNoteMessageId && creditNoteResponse) {
      if(creditNoteResponse?.errors?.length) {
        this.setState({
          creditLoader: false,
        })
        alert(creditNoteResponse.errors)
      } else {
        this.setState({
          snackbarMessage: "Credit note created successfully.",
          snackBarSeverity: "success",
          creditLoader:false,
          creditNoteOrder: undefined,
          isCreditNoteDialogOpen: false,
        });
        this.handleTabChange(6);
      }
    } else if (requestId == this.getCreditNoteMessageId && creditNoteResponse?.data) {
      const note = creditNoteResponse.data.attributes?.notes || "";
      this.setState({
        addNote: note,
        creditNoteOrderNumber: creditNoteResponse.data.attributes.order_number,
        creditNotePresent: true,
        creditNoteReceipt:  toString(creditNoteResponse.data.attributes.credit_note_receipt),
        openCrediNoteModalLoader: false
      });
    } 
    
    if (requestId == this.getCreditNoteMessageId && creditNoteResponse?.errors) {
      this.setState({ hidden: false, openCrediNoteModalLoader: false });
    }
  }


  hanldeClickPrintCreditNote = () => {
    const {creditNoteReceipt} = this.state
    if (creditNoteReceipt) {
      this.handlePrintReceipt(creditNoteReceipt)
    }
  }

  handleAddNote = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ addNote: event.target.value });
  };

  handleConfirmationCheckBox = () => {
    if (!this.state.creditNotePresent)
      this.setState({
        isConfirmationChecked: !this.state.isConfirmationChecked,
      });
  };

  getMomentFormat(dateStr: Date | string) {
    return moment(dateStr).format("DD/MM/YYYY");
  }

  handleReGenerateOrderInvoice = (order_id: number) => {
    let message = MakeApiMessage({
      url: configJSON.generateOrderInvoiceEndPoint + order_id,
      method: "GET",
    });
    this.generateOrderInvoiceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

    handleReGenerateGoldenPointOrderInvoice = (order_id: number) => {
    let message = MakeApiMessage({
      url: configJSON.generateGoldenPointOrderInvoiceEndPoint + order_id,
      method: "GET",
    });
    this.generateOrderInvoiceCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleReGenerateInvoiceResponse = (
    apiRequestCallId: string,
    response: { status: number; invoice_receipt_pdf_url: string; order_id: number}
  ) => {
    if(apiRequestCallId === this.generateOrderInvoiceCallId) {
      if (response.status == 200) {
        if (response.invoice_receipt_pdf_url) {
          // print the receipt
          this.setState((prev) => ({ordersList: prev.ordersList.map(order => order.id === toString(response.order_id) ? 
            ({...order,
              attributes: {
                ...order.attributes,
                invoice_receipt_pdf_url: response.invoice_receipt_pdf_url
            }}) : order
          )}))
          this.handlePrintReceipt(response.invoice_receipt_pdf_url);
        } else {
          this.setState({ errorMessage: "Something wrong with priniting, Please try again" });
        }
      }
    }
  };

  getRawInvoiceData = (orderId: string) => {
    if (this.savedRawPrintDatasMap.has(orderId)) {
      const payload = this.savedRawPrintDatasMap.get(orderId);
      payload && this.handleRawPrint(payload);
      return;
    }
    const isGoldenPointsOrder = this.state.orderToPrint?.attributes?.order_type === "GoldenPointsOrder";
    const apiUrl = isGoldenPointsOrder
      ? configJSON.rawGoldenPointOrderInvoiceData + orderId
      : configJSON.rawOrderInvoiceData + orderId;

    const apiMessage = MakeApiMessage({
      method: "GET",
      url: apiUrl
    });

    this.getRawOrderInvoiceDataCallId = apiMessage.messageId;
    this.send(apiMessage);
  };


  handleRawInvoiceDataResponse = (
    apiRequestCallId: string,
    response?: {
      invoice_type: string; data?: InvoiceRawData 
}
  ) => {
    if (apiRequestCallId === this.getRawOrderInvoiceDataCallId) {
      if (response?.data) {
        if (this.savedRawPrintDatasMap.size > 50) {
          const firstInsertedKey = this.savedRawPrintDatasMap.keys().next().value;
          this.savedRawPrintDatasMap.delete(firstInsertedKey as string);
        }
        if (response.invoice_type === "goldenPointOrder") {
          this.handleGoldenPointRawPrint(response.data);
          return; 
        }else if(response.invoice_type === "is_redeem_receipt"){
          this.handleRedeemRawPrint(response.data);
        }
        else{
        this.handleRawPrint(response.data);
        }

        if (response.data?.order?.order_id) {
          this.savedRawPrintDatasMap.set(
            String(response.data.order.order_id),
            response.data
          );
        }
      } else {
        this.setState({ errorMessage: "unable to fetch order data" });
      }
    }
  };

  handleReturnColorType = () => {
    const { isAppliedFilter } = this.state;
    return isAppliedFilter ? "primary" : "inherit";
  };

  handleStorageFilter = () => {
    const applied_order_management_filter = localStorage.getItem(
      "order_management_filter_value"
    );

    if (applied_order_management_filter) {
      const value = JSON.parse(applied_order_management_filter);

      let tempFilter = JSON.parse(JSON.stringify(value)) as IFilter[];

      const updateFilter = tempFilter.map((temp) => {
        if (temp.title == "Customer") {
          return {
            ...temp,
            onClear: () => {
              return this.clearCustomerFilter();
            },
            customRender: () => {
              return this.renderfilterCustomer();
            },
          };
        } else {
          return temp;
        }
      });

      this.setState(
        {
          filters: updateFilter,
          isAppliedFilter: checkIsFilterApplied(updateFilter),
        },
        () => this.handleTabChange(1)
      );
    } else {
      this.handleTabChange(1);
    }
  };

  handleSetStateFilter = (filters: IFilter[]) => {
    this.setState({ filters })
  };

  handleMomentDateFormat(date: string | Date |null, dateFormat: string) {
    const formatedDate = moment.parseZone(date).format(dateFormat);
    return formatedDate;
  }

  scanOrder = (orderNumber: string) => {
    if (this.state.isScanningOrder) return;
    if (
      this.state.orderDetailPopup
      && this.state.orderData?.id === this.scannedOrderId 
      && this.state.orderData?.attributes?.order_number === orderNumber
    ) {
      this.moveOrderToNext(this.state.orderData)
      return;
    }
    this.setState({isScanningOrder: true})
    const endPoint = configJSON.getOrderApi + `${encodeURIComponent(orderNumber)}?for_barcode=true&for_store=true`
    const message = MakeApiMessage({
      method: "GET",
      url: endPoint
    });
    this.scanOrderApiCallId = message.messageId
    this.send(message)
  }

  handleScanOrderResponse(requestId: string, response : {data?: IOrderData}) {
    if (requestId !== this.scanOrderApiCallId) return;
    const order = response?.data
    if (order && order?.attributes) {
      this.handleScanActions(order)
    }else {
      this.setState({errorMessage: "unable to find the order", isScanningOrder: false})
    }    
    
  }

  handleScanActions = (order: IOrderData) => {
    if (!order.attributes.order_items.length || order.attributes.is_quick_drop) {
      return this.setState({
        errorMessage: "This order does not have any item",
        isScanningOrder: false
      })
    }
    const {selectedDropdownvalue, tabId} = this.state
    if (selectedDropdownvalue) {
      const currentTab = TAB_STATUS_LIST[tabId]
      if (currentTab !== order.attributes.internal_status) {
        this.setState({
          errorMessage: "Cannot apply current action, the scanned order belongs to other stage",
          isScanningOrder: false 
        })
      } else {
        if (this.state.orderDetailPopup) {
          this.setState({
            orderDetailPopup: false,
            orderData: {} as IOrderData
          })
        }
        switch (selectedDropdownvalue) {
          case "Send to driver":
            this.scannedOrderId = order.id
            this.onClickSendToDriverSubmit([order])
            break;
          case "Run audits":
          case "View audits":
            const ordersList = this.getOrdersForAudits(order)
            this.setState({ordersList, isScanningOrder: false})
            break;
          default:
            this.scannedOrderId = order.id
            this.onClickSendToCleanSubmit([order])
            break;
        }
      }
    } else {
      this.setState({isScanningOrder: false})
      this.handleOpenScannedOrder(order)
    }
  }

  handleOpenScannedOrder = (order: IOrderData) => {
    if (this.state.permissionStatus.viewOrderPermission) {
      this.scannedOrderId = order.id
      this.handleOrderDetail(order)
    } else {
      this.setState({
        snackbarMessage: "You do not have permission to view this order",
        snackBarSeverity: "error"
      })
    }
  }

  handleReceiveMessageForScanner = (responseJson: {message?: string, status?: number, errors?: string}) => {
    const isSuccess = responseJson.status === 200
    this.setState((prev) => ({
      snackbarMessage : toString(responseJson.message || responseJson.errors),
      snackBarSeverity: sortStringCondition(
        isSuccess,
        "success",
        "error"
      ),
      ordersList: prev.ordersList.filter(item => item.id !== this.scannedOrderId),
      isScanningOrder: false,
      isButtonLoading: false,
      orderDetailPopup: isSuccess ? false : prev.orderDetailPopup,
      orderData: isSuccess ? ({} as IOrderData) : prev.orderData,
    }), () => {
      this.scannedOrderId = ""
    })
  }

  getOrdersForAudits = (newSelectedOrder: IOrderData) => {
    const orderIndex = this.state.ordersList.findIndex(item => item.id === newSelectedOrder.id)
    const ordersList = orderIndex > -1 ? this.state.ordersList.map(
      (item, index) => index === orderIndex ? ({ ...item, checked: true }) : item
    ) : [{ ...newSelectedOrder, checked: true }, ...this.state.ordersList]
    return ordersList
  }

  moveOrderToNext = (order: IOrderData) => {
    const {internal_status} = order.attributes
    const errorMessage = this.checkMoveToNextPermissionMessage(internal_status)
    if (errorMessage) {
      return this.setState({errorMessage, isScanningOrder: false})
    }
    const nextStatus = {
      cleaning: "ready",
      delivered: "send_to_deadstock"
    }
    switch (internal_status) {
      case "coming_to_store":
        this.handleSendToRecieve(
          [order]
        )
        break;
      case "in_store":
        break;
      case "cleaning":
      case "delivered":
        this.handleStatusChangetoAnyStatus([order],nextStatus[internal_status])
        break;
      case "ready":
        this.handleSendToDelivered([order])
        break;
      default:
        break;
    }
  }

  checkMoveToNextPermissionMessage = (internal_status: string) => {
    const {permissionStatus} = this.state
    let errorMessage = "You do not have permission to move this order to next stage"
    switch(internal_status) {
      case "in_store":
        errorMessage = "For in store order, please use Send to Driver action to move order to next stage"
        break;
      case "coming_to_store":
      case "ready":
        errorMessage = ""
        break;
      case "cleaning":
        if (permissionStatus.cleanAction) {
          errorMessage = ""
        }
        break;
      case "delivered":
        if (permissionStatus.sendToDeadStockAction) {
          errorMessage = ""
        }
        break;
      default:
        errorMessage = "This order cannot be moved"
        break;
    }
    return errorMessage
  }

  // Notes Dialog Methods
  handleOpenNotesDialog = (orderId: string, currentNotes?: string) => {
    this.setState({
      notesDialogOpen: true,
      currentOrderIdForNotes: orderId,
      tempNotes: "" // Always start with empty input for new note
    });
  };

  handleCloseNotesDialog = () => {
    this.setState({
      notesDialogOpen: false,
      currentOrderIdForNotes: null,
      tempNotes: ""
    });
  };

  handleNotesChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    this.setState({ tempNotes: event.target.value });
  };

  handleSaveNotes = async () => {
    const { currentOrderIdForNotes, tempNotes } = this.state;
    if (!currentOrderIdForNotes || tempNotes.trim() === '') return;

    this.setState({ isUpdatingNotes: true });

    // Get existing notes and append new note
    const currentOrder = this.state.ordersList.find(order => order.id === currentOrderIdForNotes);
    const existingNotes = currentOrder?.attributes?.notes || '';
    
    let updatedNotes;
    if (existingNotes.trim() === '') {
      updatedNotes = tempNotes.trim();
    } else {
      updatedNotes = existingNotes + '|' + tempNotes.trim();
    }

    const header = {
      "Content-Type": configJSON.ordersApiContentType,
      token: window.localStorage.getItem(configJSON.token),
    };

    const message = new Message(getName(MessageEnum.RestAPIRequestMessage));
    
    message.addData(
      getName(MessageEnum.RestAPIResponceEndPointMessage),
      `bx_block_order_management/orders/${currentOrderIdForNotes}/update_order_notes`
    );
    message.addData(
      getName(MessageEnum.RestAPIRequestHeaderMessage),
      JSON.stringify(header)
    );
    message.addData(
      getName(MessageEnum.RestAPIRequestBodyMessage),
      JSON.stringify({ notes: updatedNotes })
    );
    message.addData(
      getName(MessageEnum.RestAPIRequestMethodMessage),
      configJSON.patchMethod
    );

    this.updateOrderNotesCallId = message.messageId;
    runEngine.sendMessage(message.id, message);
  };

  handleUpdateNotesResponse = (responseJson: any) => {
    if (responseJson && responseJson.message) {
      // Get the updated notes from the request (existing + new)
      const currentOrder = this.state.ordersList.find(order => order.id === this.state.currentOrderIdForNotes);
      const existingNotes = currentOrder?.attributes?.notes || '';
      const updatedNotes = existingNotes.trim() === '' ? this.state.tempNotes.trim() : existingNotes + '|' + this.state.tempNotes.trim();
      
      // Update the order in the list with new notes
      const updatedOrders = this.state.ordersList.map(order => {
        if (order.id === this.state.currentOrderIdForNotes) {
          return {
            ...order,
            attributes: {
              ...order.attributes,
              notes: updatedNotes
            }
          };
        }
        return order;
      });

      this.setState({
        ordersList: updatedOrders,
        notesDialogOpen: false,
        currentOrderIdForNotes: null,
        tempNotes: "",
        isUpdatingNotes: false,
        snackbarMessage: "Note added successfully",
        snackBarSeverity: "success"
      });
    } else {
      this.setState({
        isUpdatingNotes: false,
        snackbarMessage: "Failed to add note",
        snackBarSeverity: "error"
      });
    }
  };
  // Customizable Area End
}
